import React, { useCallback, useEffect, useState, useRef, useMemo } from "react";
import { Formik, Form, Field } from "formik";
import CustomField from "./common/customField";
import { toast } from "react-toastify";
import { queueInvoiceAutoShare } from "./AutoInvoiceShareHost";
import {
  connectPrinter,
  isPrinterSupported,
  printSaleReceipt,
} from "./common/utlity/thermalPrinter";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {
  createSale,
  updateSaleService,
  verifyGSTService,
} from "../services/sale.service";
import {
  onlyNumber,
  onlyNumberdesimal,
  onlyLetters,
  onlyNumberWithExpression,
  evaluateExpression,
} from "../helpers/formats";
import { getCustomer } from "../services/customer.service";
import { getProducts, getServices } from "../services/inventory.service";
import Modal from "./common/modal/Modal";
import ProductSelection from "./productSelection";
import { initialValuesForSale } from "./common/utlity/intialValues";
import { salevalidationSchema } from "./common/utlity/validationSchema";
import { BsTrash } from "react-icons/bs";
import { Country, State } from "country-state-city";
import { calculateDiscount } from "./common/utlity/sale.utility";
import { useTranslation } from "react-i18next";
import PaymentOptions, { SCANNER_PAYMENT_OPTION } from "../pages/sale/SalePayment";
import SaleQrPaymentModal from "../pages/sale/SaleQrPaymentModal";
import { collectSalePayment } from "../services/saleCheckout";
import SalePaylater from "../pages/sale/SalePayLater";
import "../components/common/text-color/textColor.css";
import { HiOutlineMicrophone } from "react-icons/hi";
import DateSelector from "./subscriptionDates";
import {
  optionsForSubscription,
  optionsForCustomertype,
  optionsForSaleType,
  optionsForDeliveryType,
  optionsForSaleTypeWithAdvance,
  STATE_CODE_MAP,
} from "./common/utlity/options";
import { isPastDate } from "./common/utlity/utility";
import BeatLoader from "react-spinners/BeatLoader";
import { useSelector } from "react-redux";
import { ToggleButton } from "./common/commonLable";
import SaleInvoice from "../../src/pages/sale/SaleInvoice";
import { addEstimate } from "../services/estimate.service";
import CustomPhoneNumberField from "../components/common/customPhone";
import { useParams, useNavigate } from "react-router-dom";
import { getCurrencySymbol } from "../components/common/utlity/options";
import TourGuide from "./common/TourGuide";
import { SaleSteps } from "../lib/constants/TourSteps";
import {
  FiChevronDown,
  FiArrowLeft,
  FiChevronUp,
  FiSettings,
  FiPackage,
} from "react-icons/fi";
import moment from "moment";
import { applyCoupon, increaseCouponUsage } from "../services/coupon.service";
import { VariantSelectionModal } from "./variant/variantModelsSaleBuy";
import { useBusinessSettings } from "./sidebar/BusinessSettingsContext";

const normalizeMobile = (mobile) => {
  if (!mobile) return "";
  return mobile
    .toString()
    .replace(/\D/g, "") // remove all non-digits
    .replace(/^0+/, "") // remove leading zeros
    .replace(/^91/, "") // remove country code 91
    .slice(-10); // keep last 10 digits (Indian mobile)
};
// ===== BARCODE HELPERS =====
const toQty = (v) => {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
};
const roundQty = (n) => Math.round(n * 1000) / 1000;
const PRODUCT_CODE_KEYS = ["ean", "sku_number"]; 
const VARIANT_CODE_KEYS = ["sku"];              

const normCode = (v) =>
  v === undefined || v === null
    ? ""
    : String(v).trim().toLowerCase().replace(/^0+(?=.)/, ""); 

const getCodes = (obj, keys) => {
  const out = [];
  if (!obj) return out;
  keys.forEach((k) => {
    const c = normCode(obj[k]);
    if (c) out.push(c);
  });
  return out;
};

let sharedAudioCtx = null;
const playBeep = (ok = true) => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!sharedAudioCtx) sharedAudioCtx = new Ctx();
    if (sharedAudioCtx.state === "suspended") sharedAudioCtx.resume();
    const o = sharedAudioCtx.createOscillator();
    const g = sharedAudioCtx.createGain();
    o.frequency.value = ok ? 1000 : 300;
    g.gain.value = 0.05;
    o.connect(g);
    g.connect(sharedAudioCtx.destination);
    o.start();
    o.stop(sharedAudioCtx.currentTime + (ok ? 0.08 : 0.25));
  } catch (e) {}
};
const NewSale = ({
  close,
  item,
  addSale,
  readOnly = false,
  disableAllInteractions = false,
  businessUuid,
  initialValues,
}) => {
  const getInitialProductSections = () => {
    if (item && item.items && item.items.length > 0) {
      return item.items;
    }
    return [
      {
        productName: "",
        quantity: 1,
        subscriptionType: "",
        salePrice: "",
        discount: 0,
        discountUnit: "",
        gstPercent: "",
        finalPrice: "",
        productId: "",
        purchasePrice: 0,
        status: "Active",
        sub_discount: "",
        country: "",
        state: "",
        address: "",
        listening: false,
        productSubCategory: "",
        productCategory: "",
        brandName: "",
        batchNumber: "",
        expDate: "",
        unitSize: "",
        mfgDate: "",
        igst: 0,
        cgst: 0,
        sgst_utgst: 0,
        cess: 0,
        showReturn: false,
        returnPeriod: "",
        hsnNumber: "",
        bulkPriceEligible: false,
        hasVariants: false,
        variantId: "",
        variantName: "",
        variantDetails: null,
        variantAttributes: [],
        variantSku: "",
        variantStock: 0,
      },
    ];
  };

  const [productSections, setProductSections] = useState(
    getInitialProductSections,
  );
  const [appliedOrderCoupon, setAppliedOrderCoupon] = useState(null);
  const [orderCouponDiscount, setOrderCouponDiscount] = useState(0);
  const [orderCouponCode, setOrderCouponCode] = useState("");
  const [appliedCouponType, setAppliedCouponType] = useState(null);
  const { t } = useTranslation();
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [disableName, setDisableName] = useState(false);
  const [additionalDiscount, setAdditionalDiscount] = useState([]);
  const [additionalFee, setAdditionalFee] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [export_sale, setExport_sale] = useState(item?.export_sale || false);
  const [isProducts, setIsProducts] = useState(item?.isProducts || true);
  const [isServices, setIsServices] = useState(item?.isServices || false);
  const [saleTypes, setSaleTypes] = useState(item ? item.saleType : "");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [igst, setIgst] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);
  const [cess, setCess] = useState(0);
  const [sez, setSez] = useState(item?.sez || false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [products, setProducts] = useState([]);
  const [service, setService] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenFullPayment, setIsOpenFullPayment] = useState(false);
  const [isOpenPayPartial, setIsOpenPayPartial] = useState(false);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const { bussinessUuid: paramUuid } = useParams();
  const finalBusinessUuid = businessUuid || paramUuid;
  const businessData = useSelector((state) => state.bussiness.business);
  const business = Array.isArray(businessData)
    ? businessData.find((b) => b.bussinessUuid === finalBusinessUuid) ||
      businessData[0]
    : businessData;
  const navigate = useNavigate();

  const [showFilter, setShowFilter] = useState(false);
  const [advanceAmount, setAdvanecAmount] = useState(
    item ? item.advancePayment : 0,
  );
  const [moreAdvancePayment, setMoreAdvancePayment] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(item ? item?.deliveryFee : 0);
  const [customerVoiceInput, setCustomerVoiceInput] = useState("");
  const [listening, setListening] = useState(false);
  const [listeningMobile, setListeningMobile] = useState(false);
  const [listeningCustomerName, setListeningCustomerName] = useState(false);
  const [saleIsLoading, setSaleIsLoading] = useState(false);
  const [qrSession, setQrSession] = useState(null);
  const qrSaleContextRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [intraState, setIntraState] = useState(item ? item.intraState : false);
  const [showGST, setShowgst] = useState(item ? item?.showGST : true);
  const sales = useSelector((state) => state?.sales.sales);
  const [runTour, setRunTour] = useState(false);
  const [includingTax, setIncludingTax] = useState(item?.includingTax || false);

  const [showVariantModal, setShowVariantModal] = useState(false);
  const [selectedProductForVariant, setSelectedProductForVariant] =
    useState(null);
  const [selectedProductIndex, setSelectedProductIndex] = useState(null);

  const { settings: businessSettings } = useBusinessSettings();
  const saleSettings = businessSettings?.saleSettings;
  const isProportional = saleSettings?.saleCalculation !== "normal";
  const discountEnabled = saleSettings?.enableDiscountField !== false;
  const subscriptionEnabled = saleSettings?.enableSubscriptionField !== false;
  const saleTypeOptions =
    saleSettings?.enableAdvancePayment === false
      ? optionsForSaleType.filter((option) => option.value !== "advancePayment")
      : optionsForSaleType;

  const [visibleFields, setVisibleFields] = useState({
    subscription: false,
    discount: false,
    disUnit: false,
    igst: false,
    cgst: false,
    sgst: false,
    cess: false,
    taxIncluded: true,
  });

  useEffect(() => {
    const waitForElements = () => {
      const allElementsExist =
        document.querySelector(".sale-type-tour") &&
        document.querySelector(".delivery-type-tour");

      if (sales?.length === 0 && allElementsExist) {
        setRunTour(true);
      } else {
        setTimeout(waitForElements, 300);
      }
    };

    waitForElements();
  }, [sales]);
  useEffect(() => {}, [intraState]);
  const closeInvoice = () => {
    setShowInvoice(false);
    close();
  };

  const getsetProduct = useCallback(() => {
    if (item && item.items && item.items.length > 0) {
      setProductSections(item.items);
    }
  }, [item]);

  const handleVariantSelect = (variant, quantity, index) => {
    setProductSections((prevSections) => {
      const newSections = [...prevSections];
      const section = { ...newSections[index] };

      const selectedProduct = selectedProductForVariant;

      section.productId = selectedProduct?.productId || section.productId;
      section.productName = selectedProduct?.productName || section.productName;
      section.hasVariants = true;

      section.variantId = variant.variantId;
      section.variantName = variant.variantName;
      section.variantDetails = {
        ...variant,
        productId: selectedProduct?.productId,
      };
      section.variantAttributes = variant.attributes || [];
      section.variantSku = variant.sku || "";
      section.variantStock = variant.quantity || 0;
      // section.quantity = quantity;
      section.quantity = toQty(quantity);
      section.salePrice = variant.salePrice || section.salePrice;
      section.purchasePrice = variant.purchasePrice || section.purchasePrice;
      section.batchNumber = variant.batchNumber || section.batchNumber;
      section.mfgDate = variant.mfgDate || section.mfgDate;
      section.expDate = variant.expDate || section.expDate;

      section.subscriptionEligible =
        selectedProduct?.subscriptionEligible || false;
      section.bulkPriceEligible = selectedProduct?.bulkPriceEligible || false;
      section.subscription = selectedProduct?.subscription || [];
      section.bulkPrice = selectedProduct?.bulkPrice || [];
      section.igst = selectedProduct?.igst || "0";
      section.cgst = selectedProduct?.cgst || "0";
      section.sgst_utgst = selectedProduct?.sgst_utgst || "0";
      section.cess = selectedProduct?.cess || "0";
      section.showReturn = selectedProduct?.showReturn || false;
      section.returnPeriod = selectedProduct?.returnPeriod || "";
      section.hsnNumber = selectedProduct?.hsnNumber || "";

      const salePrice = parseFloat(section.salePrice) || 0;
      const discount = parseFloat(section.discount) || 0;
      const discountedPrice =
        section.discountUnit === "%"
          ? salePrice * (1 - discount / 100)
          : salePrice - discount;

      const igst = parseFloat(section.igst) || 0;
      const cgst = parseFloat(section.cgst) || 0;
      const sgst = parseFloat(section.sgst_utgst) || 0;
      const cess = parseFloat(section.cess) || 0;

      const isTaxExempt =
        export_sale === true || sez === true || showGST === false;
      const isSameState = intraState === false;

      let finalPrice = discountedPrice;

      if (!isTaxExempt) {
        if (isSameState) {
          finalPrice += (discountedPrice * (cgst + sgst + cess)) / 100;
        } else {
          finalPrice += (discountedPrice * (igst + cess)) / 100;
        }
      }

      section.finalPrice = Math.ceil(finalPrice * quantity);
      newSections[index] = section;

      return newSections;
    });

    toast.success(`Variant "${variant.variantName}" added to sale`);
  };

  const handleSelectVariantClick = (index) => {
    const section = productSections[index];
    if (section.hasVariants && !section.variantId) {
      setSelectedProductForVariant(section);
      setSelectedProductIndex(index);
      setShowVariantModal(true);
    } else if (section.variantId) {
      setSelectedProductForVariant(section);
      setSelectedProductIndex(index);
      setShowVariantModal(true);
    }
  };

  const handleFieldVisibility = (field, value) => {
    const newFields = { ...visibleFields, [field]: value };
    if (field === "discount" && visibleFields.discount === true) {
      const newSections = productSections.map((section) => ({
        ...section,
        discount: "0",
      }));
      setProductSections(newSections);

      newSections.forEach((_, index) => {
        calculateFinalPrice(index, newSections);
      });
    }
    if (field === "igst" && visibleFields.igst === true) {
      const newSections = productSections.map((section) => ({
        ...section,
        igst: "0",
      }));
      setProductSections(newSections);

      newSections.forEach((_, index) => {
        calculateFinalPrice(index, newSections);
      });
    }
    if (field === "cgst" && visibleFields.cgst === true) {
      const newSections = productSections.map((section) => ({
        ...section,
        cgst: "0",
      }));

      setProductSections(newSections);

      newSections.forEach((_, index) => {
        calculateFinalPrice(index, newSections);
      });
    }
    if (field === "sgst" && visibleFields.sgst === true) {
      const newSections = productSections.map((section) => ({
        ...section,
        sgst: "0",
      }));

      setProductSections(newSections);

      newSections.forEach((_, index) => {
        calculateFinalPrice(index, newSections);
      });
    }
    if (field === "cess" && visibleFields.cess === true) {
      const newSections = productSections.map((section) => ({
        ...section,
        cess: "0",
      }));
      setProductSections(newSections);

      newSections.forEach((_, index) => {
        calculateFinalPrice(index, newSections);
      });
    }
    if (field === "igst" && value && value.intraState) {
      newFields.cgst = false;
      newFields.sgst = false;
    }

    if ((field === "cgst" || field === "sgst") && value && !value.intraState) {
      newFields.igst = false;
    }

    setVisibleFields(newFields);
  };

const transformProducts = (products, isServices = false) => {
  const today = moment().startOf("day");
  const validProducts = products.filter((product) => {
    if (product?.expDate) {
      const expDate = moment(product.expDate, "DD-MM-YYYY");
      if (expDate.isBefore(today)) {
        toast.error(
          `${product.productName || product.serviceName} has expired.`,
        );
        return false;
      }
    }
    return true;
  });

  return validProducts.map((product) => {
    const qty =
      Number(product.quantity) > 0 ? Number(product.quantity) : 1;

    const salePrice = parseFloat(product.salePrice) || 0;
    const finalDis = calculateDiscount(product);
    let finalPrice = salePrice - finalDis;
    const igst = parseFloat(product.igst) || 0;
    const cgst = parseFloat(product.cgst) || 0;
    const sgst = parseFloat(product.sgst_utgst) || 0;
    const cess = parseFloat(product.cess) || 0;

    const isTaxExempt =
      export_sale === true || sez === true || showGST === false;
    const isSameState = intraState === false;

    const shouldCalculateTax =
      !includingTax && !isTaxExempt && !product.taxIncluded;

    if (shouldCalculateTax) {
      if (isSameState) {
        finalPrice += (finalPrice * (cgst + sgst + cess)) / 100;
      } else {
        finalPrice += (finalPrice * (igst + cess)) / 100;
      }
    }

    if (isServices === true) {
      return {
        productName: product.serviceName,
        quantity: qty,
        subscriptionType: "",
        salePrice: product.salePrice,
        discount: 0,
        finalPrice: Math.ceil(finalPrice) * qty,
        serviceId: product.serviceId,
        subscriptionEligible: product.subscriptionEligible,
        purchasePrice: product.serviceCost,
        subscription: product.subscription,
        productSubCategory: product.productSubCategory,
        productCategory: product.productCategory,
        unitSize: product.unitSize,
        brandName: product.brandName,
        batchNumber: product.batchNumber,
        expDate: product.expDate,
        mfgDate: product.mfgDate,
        subscriptionOption: optionsForSubscription(product.subscription),
        igst: product?.igst,
        cgst: product?.cgst,
        sgst_utgst: product?.sgst_utgst || 0,
        cess: product?.cess,
        showReturn: product?.showReturn,
        returnPeriod: product?.returnPeriod,
        hsnNumber: product?.hsnNumber,
        taxIncluded: product.taxIncluded || false,
        hasVariants: false,
        variants: [],
      };
    }

    return {
      productName: product.productName,
      quantity: qty,
      subscriptionType: "",
      salePrice: salePrice,
      discount: product.saleDiscount,
      discountUnit: product.saleDiscountUnit,
      finalPrice: Math.ceil(finalPrice) * qty,
      productId: product.productId,
      subscriptionEligible: product.subscriptionEligible,
      bulkPriceEligible: product.bulkPriceEligible,
      purchasePrice: product.purchasePrice,
      subscription: product.subscription,
      productSubCategory: product.productSubCategory,
      productCategory: product.productCategory,
      unitSize: product.unitSize,
      baseUnitSize: product.unitSize,
      additionalUnit: product.additionalUnit || "",
      conversionQty: product.conversionQty || 0,
      saleUnitType: "main",
      brandName: product.brandName,
      batchNumber: product.batchNumber,
      expDate: product.expDate,
      mfgDate: product.mfgDate,
      subscriptionOption: optionsForSubscription(product.subscription),
      igst: product?.igst,
      cgst: product?.cgst,
      sgst_utgst: product?.sgst_utgst,
      cess: product?.cess,
      showReturn: product?.showReturn,
      returnPeriod: product?.returnPeriod,
      hsnNumber: product?.hsnNumber,
      bulkPrice: product?.bulkPrice,
      taxIncluded: product.taxIncluded || false,
      hasVariants: product.hasVariants || false,
      variants: product.variants || [],
    };
  });
};

  useEffect(() => {
    if (productSections.length > 0) {
      setTimeout(() => {
        const sectionCopy = [...productSections];
        sectionCopy.forEach((_, index) => {
          calculateFinalPrice(index, sectionCopy);
        });
      }, 50);
    }
  }, [includingTax]);

  const handleToggleAllFields = (e) => {
    const newValue = e.target.checked;
    const updatedFields = Object.fromEntries(
      Object.entries(visibleFields).map(([key]) => [
        key,
        (key === "subscription" && !subscriptionEnabled) ||
        ((key === "discount" || key === "disUnit") && !discountEnabled)
          ? false
          : newValue,
      ]),
    );
    setVisibleFields(updatedFields);
  };

  useEffect(() => {
    setTimeout(() => {
      const sectionCopy = [...productSections];
      sectionCopy.forEach((_, index) => {
        calculateFinalPrice(index, sectionCopy);
      });
    }, 50);
  }, [visibleFields, additionalDiscount, showGST, additionalFee]);

  const recalculatePrice = useCallback(
    (index) => {
      setProductSections((prevSections) => {
        const newSections = [...prevSections];
        const updatedSection = { ...newSections[index] };

        const salePrice = parseFloat(updatedSection.salePrice) || 0;
        // const quantity = parseInt(updatedSection.quantity) || 1;
        const quantity = toQty(updatedSection.quantity);
        const discount = parseFloat(updatedSection.discount) || 0;
        const discountUnit = updatedSection.discountUnit;

        let discountedPrice = salePrice;

        if (discountUnit === "%") {
          discountedPrice -= (salePrice * discount) / 100;
        } else {
          discountedPrice -= discount;
        }

        const igst = parseFloat(updatedSection.igst) || 0;
        const cgst = parseFloat(updatedSection.cgst) || 0;
        const sgst = parseFloat(updatedSection.sgst_utgst) || 0;
        const cess = parseFloat(updatedSection.cess) || 0;

        const isTaxExempt = export_sale === true || sez === true;
        const isSameState = intraState === false;

        let finalPrice = discountedPrice;

        if (isTaxExempt && showGST == true) {
          if (isSameState) {
            finalPrice += (salePrice * (cgst + sgst + cess)) / 100;
          } else {
            finalPrice += (salePrice * (igst + cess)) / 100;
          }
        }

        finalPrice = finalPrice * quantity;

        updatedSection.finalPrice = finalPrice.toFixed(2);
        newSections[index] = updatedSection;
        return newSections;
      });
    },
    [export_sale, sez, showGST, intraState],
  );
  useEffect(() => {
    productSections.forEach((_, index) => {
      calculateFinalPrice(index);
    });
  }, [
    productSections.length,
    orderCouponDiscount,
    appliedCouponType,
    appliedOrderCoupon,
  ]);
  const handleApplyOrderCoupon = async () => {
    try {
      if (!orderCouponCode) {
        toast.error("Enter Order Coupon");
        return;
      }

      const payload = {
        couponName: orderCouponCode,
        cartItems: productSections.map((p) => ({
          productId: p.productId || p.variantDetails?.productId,
          // qty: p.quantity,
          qty: toQty(p.quantity),
          price: p.finalPrice,
        })),
        orderTotal: calculateTotalTransactionAmount(),
      };

      const res = await applyCoupon(finalBusinessUuid, payload);

      setAppliedOrderCoupon(orderCouponCode);
      setOrderCouponDiscount(parseFloat(res.data.discount.toFixed(2)));

      setAppliedCouponType(res.data.couponType);

      toast.success("Coupon Applied Successfully");

      productSections.forEach((_, index) => {
        calculateFinalPrice(index);
      });
    } catch (err) {
      toast.error(err.response?.data?.message || "Coupon Failed");
    }
  };

  useEffect(() => {
    if (appliedOrderCoupon) {
      handleApplyOrderCoupon();
    }
  }, [productSections.map((s) => s.quantity).join(",")]);

  const removeOrderCoupon = () => {
    setAppliedOrderCoupon(null);
    setOrderCouponDiscount(0);
    setAppliedCouponType(null);

    productSections.forEach((_, index) => {
      calculateFinalPrice(index);
    });
  };
  useEffect(() => {
    if (productSections.length > 0) {
      productSections.forEach((section, index) => {
        recalculatePrice(index, productSections);
      });
    }
  }, [
    export_sale,
    sez,
    intraState,
    JSON.stringify(
      productSections.map((section) => ({
        salePrice: section.salePrice,
        discount: section.discount,
        discountUnit: section.discountUnit,
        igst: section.igst,
        cgst: section.cgst,
        sgst_utgst: section.sgst_utgst,
        cess: section.cess,
        quantity: section.quantity,
      })),
    ),
    recalculatePrice,
  ]);

  useEffect(() => {
    getSetCustomers();
    getSetProducts();
    getSetServices();

    const countryList = Country.getAllCountries().map((country) => ({
      label: country.name,
      value: country.isoCode,
    }));

    const stateList = State.getStatesOfCountry(user.country || "IN").map(
      (state) => ({
        label: state.name,
        value: state.isoCode,
      }),
    );

    setStates(stateList);
    setCountries(countryList);
  }, [user.country]);

  useEffect(() => {
    getsetProduct();
  }, [getsetProduct]);

useEffect(() => {
  if (item) {
    setSaleTypes(item.saleType || "");
    setAdvanecAmount(item.advancePayment || 0);
    setMoreAdvancePayment(0);
    setDeliveryFee(item?.deliveryFee || 0);
    setIntraState(item.intraState || false);
    setShowgst(item?.showGST !== undefined ? item.showGST : true);
    setExport_sale(item?.export_sale || false);
    setSez(item?.sez || false);
    setIsProducts(item?.isProducts !== undefined ? item.isProducts : true);
    setIsServices(item?.isServices || false);
    setIncludingTax(item?.includingTax || false);
  }
}, [item]);


  const handleCountryChange = (setFieldValue, countryIsoCode) => {
    setFieldValue("country", countryIsoCode);
    const stateList = State.getStatesOfCountry(countryIsoCode || "IN").map(
      (state) => ({
        label: state.name,
        value: state.isoCode,
      }),
    );
    setStates(stateList);
    setFieldValue("state", "");
  };

  const getSetCustomers = async () => {
    const result = await getCustomer(finalBusinessUuid, { all: true });
    if (result.status === 200) {
      setCustomers(result.data.data);
    }
  };
  const getSetProducts = async () => {
    const result = await getProducts(finalBusinessUuid, { all: true });
    if (result.status === 200) {
      setProducts(result.data.data);
    }
  };
  const getSetServices = async () => {
    const result = await getServices(finalBusinessUuid, { all: true });
    if (result.status === 200) {
      setService(result.data.data);
    }
  };

  // ========== FIXED: findCustomerNameByMobile uses normalizeMobile ==========
  const findCustomerNameByMobile = (mobileNumber) => {
    if (!mobileNumber) return null;
    const target = normalizeMobile(mobileNumber);
    if (!target) return null;

    const customer = customers.find(
      (c) => normalizeMobile(c.customer_mobile) === target,
    );
    return customer || null;
  };

  // ========== FIXED: filterCustomers — search by name OR number ==========
  const filterCustomers = (inputValue) => {
    if (!inputValue) {
      setFilteredCustomers([]);
      return;
    }

    const rawSearch = inputValue.toString().trim();
    const digitsOnly = rawSearch.replace(/\D/g, "");
    const searchTerm = normalizeMobile(rawSearch);
    const searchName = rawSearch.toLowerCase();

    // Decide search mode: if user typed mostly digits, search by number
    const isNumericSearch = digitsOnly.length >= 2;
    // If user typed letters, search by name (require >= 2 chars)
    const isNameSearch = !isNumericSearch && searchName.length >= 2;

    if (!isNumericSearch && !isNameSearch) {
      setFilteredCustomers([]);
      return;
    }

    const filtered = customers.filter((customer) => {
      const rawMobile = customer?.customer_mobile || customer?.mobile || "";
      const mobile = normalizeMobile(rawMobile);
      const name = (customer?.name || customer?.customerName || "")
        .toString()
        .toLowerCase();

      // Mobile search: match if normalized mobile contains searchTerm
      // Also allow raw digit substring match for partial numbers
      const mobileMatches =
        isNumericSearch &&
        (mobile.includes(searchTerm) ||
          String(rawMobile).replace(/\D/g, "").includes(digitsOnly));

      // Name search: substring match
      const nameMatches = isNameSearch && name.includes(searchName);

      return mobileMatches || nameMatches;
    });

    setFilteredCustomers(filtered.slice(0, 10));
  };

  // ========== FIXED: checkExistingCustomerByMobile uses normalizeMobile ==========
  const checkExistingCustomerByMobile = (mobile, name) => {
    if (!mobile) return { exists: false };

    const cleanMobile = normalizeMobile(mobile);
    if (!cleanMobile) return { exists: false };

    const existing = customers.find(
      (c) => normalizeMobile(c.customer_mobile) === cleanMobile,
    );

    if (existing) {
      const existingName = (existing.name || "").toLowerCase().trim();
      const newName = (name || "").toLowerCase().trim();

      if (existingName && newName && existingName !== newName) {
        return { exists: true, customer: existing, mismatch: true };
      }
      return { exists: true, customer: existing, mismatch: false };
    }
    return { exists: false };
  };
 

  const handleMobileInputChange = (phone, country, setFieldValue) => {
    setFieldValue("mobile", phone);
    if (phone && phone.replace(/\D/g, "").length >= 2) {
      filterCustomers(phone);
    } else {
      setFilteredCustomers([]);
    }
  };

  const handleShowPopup = () => {
    setShowPopup(false);
  };

  // ========== FIXED: handleCustomerSelect uses normalizeMobile ==========
  const handleCustomerSelect = (mobile, setFieldValue) => {
    const normalizedSearch = normalizeMobile(mobile);
    const matchedCustomer = customers.find(
      (c) => normalizeMobile(c.customer_mobile) === normalizedSearch,
    );

    if (!matchedCustomer) {
      setFieldValue("mobile", mobile);
      setFilteredCustomers([]);
      return;
    }

    setFieldValue("mobile", matchedCustomer.customer_mobile || mobile);
    setDisableName(true);
    setCustomerVoiceInput(matchedCustomer.name || "");
    setFieldValue("customerName", matchedCustomer.name || "");
    setFieldValue("state", matchedCustomer.state || "");
    setFieldValue("address", matchedCustomer.customer_address || "");
    setFieldValue("gstNo", matchedCustomer.gstIN || "");
    setFilteredCustomers([]);
  };

  const handleIsOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleIsOpenForFullPayment = () => {
    setIsOpenFullPayment(!isOpenFullPayment);
  };

  const handleIsOpenForPayParial = () => {
    setIsOpenPayPartial(!isOpenPayPartial);
  };
  const handleChangePaymentMethod = (value, isPartial = false) => {
    onSubmit(value);
    if (isPartial === true) {
      handleIsOpenForPayParial();
    } else {
      handleIsOpenForFullPayment();
    }
  };

const handleSelectedProducts = async (selectedProducts) => {
  const transformedProducts = await transformProducts(
    selectedProducts,
    isServices === true ? true : false,
  );

  setProductSections((prev) => {
    // if the only row is the empty placeholder, drop it
    const base =
      prev.length === 1 && !prev[0].productName ? [] : [...prev];

    // merge by (productId + variantId) so re-selecting the same
    // product updates the existing row instead of duplicating it
    const merged = [...base];

    transformedProducts.forEach((incoming) => {
      const idx = merged.findIndex(
        (row) =>
          row.productId === incoming.productId &&
          (row.variantId || "") === (incoming.variantId || ""),
      );

      if (idx >= 0) {
        const existing = merged[idx];
        const unitPrice =
          Number(incoming.salePrice) || Number(existing.salePrice) || 0;
        merged[idx] = {
          ...existing,
          ...incoming,
          quantity: incoming.quantity,
          finalPrice: Math.ceil(unitPrice * incoming.quantity),
        };
      } else {
        merged.push(incoming);
      }
    });

    // recompute finals for every row so taxes / additional discounts
    // and the running total stay fresh
    setTimeout(() => {
      merged.forEach((_, i) => calculateFinalPrice(i, merged));
    }, 0);

    return merged;
  });

  setVisibleFields((prev) => ({
    ...prev,
    subscription: true,
    discount: true,
    disUnit: true,
    igst: true,
    cgst: true,
    sgst: true,
    cess: true,
  }));
};

  const updateTaxStates = (values) => {
    let totalIgst = 0;
    let totalCgst = 0;
    let totalSgst = 0;
    let totalCess = 0;

    const isTaxExempt =
      export_sale === true || sez === true || values.showGST === false;
    const isSameState = values.intraState === false;

    const originalBases = productSections.map((section) => {
      const {
        salePrice = 0,
        discount = 0,
        discountUnit,
        quantity = 1,
      } = section;

      let base = parseFloat(salePrice) || 0;

      if (discountUnit === "%") {
        base -= (base * parseFloat(discount || 0)) / 100;
      } else {
        base -= parseFloat(discount || 0);
      }

      // return Math.max(base * quantity, 0);
      return Math.max(base * toQty(quantity), 0);
    });

    const totalOriginalBase = originalBases.reduce((s, v) => s + v, 0);

    let totalDiscountPercentage = 0;
    let totalFeeAmount = 0;

    let discountAllocations = originalBases.map(() => 0);
    let feeAllocations = originalBases.map(() => 0);

    if (isProportional) {
      (additionalDiscount || []).forEach((item) => {
        if (!item || !item.amount) return;
        if (item.type === "%") {
          totalDiscountPercentage += parseFloat(item.amount) || 0;
        } else if (item.type === "₹") {
          totalFeeAmount -= parseFloat(item.amount) || 0;
        }
      });

      (additionalFee || []).forEach((item) => {
        if (!item || !item.amount) return;
        if (item.type === "₹") {
          totalFeeAmount += parseFloat(item.amount) || 0;
        } else if (item.type === "%") {
          totalDiscountPercentage += parseFloat(item.amount) || 0;
        }
      });

      const proportions =
        totalOriginalBase > 0
          ? originalBases.map((b) => b / totalOriginalBase)
          : productSections.map(() => 0);

      discountAllocations = originalBases.map(
        (base, i) => (base * totalDiscountPercentage * proportions[i]) / 100,
      );

      feeAllocations = proportions.map((p) => totalFeeAmount * p);
    }

    productSections.forEach((section, i) => {
      const { igst = 0, cgst = 0, sgst_utgst = 0, cess = 0 } = section;

      const adjustedBase =
        !isProportional
          ? originalBases[i]
          : originalBases[i] - discountAllocations[i] + feeAllocations[i];

      if (!isTaxExempt) {
        if (isSameState) {
          totalCgst += (adjustedBase * parseFloat(cgst || 0)) / 100;
          totalSgst += (adjustedBase * parseFloat(sgst_utgst || 0)) / 100;
          totalCess += (adjustedBase * parseFloat(cess || 0)) / 100;
        } else {
          totalIgst += (adjustedBase * parseFloat(igst || 0)) / 100;
          totalCess += (adjustedBase * parseFloat(cess || 0)) / 100;
        }
      }
    });

    setIgst(totalIgst.toFixed(2));
    setCgst(totalCgst.toFixed(2));
    setSgst(totalSgst.toFixed(2));
    setCess(totalCess.toFixed(2));
  };

  function calculateTotalTransactionAmount(values) {
    let totalAmount = 0;
    productSections.forEach((section) => {
      totalAmount += parseFloat(section.finalPrice) || 0;
    });

    let finalAmount = totalAmount;
    if (appliedOrderCoupon && appliedCouponType === "ORDER") {
      finalAmount -= orderCouponDiscount;
    }
    if (!isProportional) {
      values.additionalDiscount?.forEach((item) => {
        const amount = parseFloat(item.amount) || 0;

        if (item.type === "%") {
          finalAmount -= (finalAmount * amount) / 100;
        } else {
          finalAmount -= amount;
        }
      });

      values.additionalFee?.forEach((item) => {
        const amount = parseFloat(item.amount) || 0;

        if (item.type === "%") {
          finalAmount += (finalAmount * amount) / 100;
        } else {
          finalAmount += amount;
        }
      });
    }

    if (saleTypes === "advancePayment" || saleTypes === "advanceSale") {
      finalAmount -= parseFloat(advanceAmount) || 0;

      if (item) {
        finalAmount -= parseFloat(moreAdvancePayment) || 0;
      }
    }

    return finalAmount.toFixed(2);
  }


  function calculateTotalProfit() {
    let totalProfit = 0;
    productSections.forEach((section) => {
      const sellPrice = parseFloat(section.salePrice) || 0;
      const purchasePrice = parseFloat(section.purchasePrice) || 0;
      // const quantity = section.quantity || 1;
      const quantity = toQty(section.quantity);
      const discount = parseFloat(section.discount) || 0;
      const salePriceWithDiscount = sellPrice - (sellPrice * discount) / 100;
      const netProfit = (salePriceWithDiscount - purchasePrice) * quantity;
      totalProfit += netProfit;
    });
    return Math.ceil(totalProfit);
  }

  const itemsWithCoupon = productSections.map((item) => {
    let couponInfo = {};

    if (appliedCouponType === "PRODUCT") {
      couponInfo = {
        couponName: appliedOrderCoupon || "",
        couponDiscount: item.couponDiscount || 0,
      };
    }

    return {
      ...item,
      ...couponInfo,
    };
  });

const goToSaleList = () => {
  navigate(`/${finalBusinessUuid}/dashboard/bills/sale`, { replace: true });
};
const onSubmit = async (values, helpers) => {
  const { resetForm } = helpers || {};

  if (!finalBusinessUuid) {
    toast.error("Business UUID is missing");
    return;
  }

  // ========== Duplicate customer check ==========
  const existingCheck = checkExistingCustomerByMobile(
    values.mobile,
    values.customerName,
  );

  if (existingCheck.exists && existingCheck.mismatch) {
    toast.error(
      `This mobile number is already registered as "${existingCheck.customer.name}". ` +
        `Please use the existing customer or select it from the search.`,
    );
    return;
  }
  // ========== END OF DUPLICATE CHECK ==========

  const invalidProducts = productSections.filter((section) => {
    if (section.variantId && section.variantDetails) {
      return !section.productName || !section.variantId;
    }
    return !section.productName || !section.productId;
  });

  if (invalidProducts.length > 0) {
    toast.error(`Please select valid products for all items`);
    return;
  }

  const productsWithIncompleteVariants = productSections.filter(
    (section) =>
      section.variantId && (!section.variantDetails || !section.variantName),
  );

  if (productsWithIncompleteVariants.length > 0) {
    toast.error(`Please complete variant selection for all items`);
    return;
  }

  const { transactionAmount, additionalFee, additionalDiscount, ...rem } =
    values;

  const itemsWithVariants = productSections.map((section, index) => {
    let finalProductId = section.productId;
    let finalHasVariants = section.hasVariants;

    if (section.variantId && section.variantDetails) {
      if (!finalProductId && section.variantDetails.productId) {
        finalProductId = section.variantDetails.productId;
      }
      finalHasVariants = true;
    }

    let itemData = {
      ...section,
      productName: section.productName || "",
      productId: finalProductId || "",
      quantity: toQty(section.quantity),
      salePrice: section.salePrice || "0",
      finalPrice: section.finalPrice || "0",
      purchasePrice: section.purchasePrice || "0",
      discount: section.discount || "0",
      discountUnit: section.discountUnit || "%",
      igst: section.igst || "0",
      cgst: section.cgst || "0",
      sgst_utgst: section.sgst_utgst || "0",
      cess: section.cess || "0",
      hasVariants: finalHasVariants,
      variantId: section.variantId || null,
      variantName: section.variantName || null,
      variantAttributes: section.variantAttributes || [],
      variantSku: section.variantSku || null,
      variantStock: section.variantStock || 0,
      variantData: section.variantId
        ? {
            variantId: section.variantId,
            variantName: section.variantName,
            variantAttributes: section.variantAttributes || [],
            variantSku: section.variantSku,
          }
        : null,
    };

    if (
      section.variantDetails &&
      section.variantDetails.productId &&
      !itemData.productId
    ) {
      itemData.productId = section.variantDetails.productId;
    }

    if (appliedCouponType === "PRODUCT") {
      itemData = {
        ...itemData,
        couponName: appliedOrderCoupon || "",
        couponDiscount: section.couponDiscount || 0,
      };
    }
    Object.keys(itemData).forEach((key) => {
      if (itemData[key] === undefined || itemData[key] === null) {
        delete itemData[key];
      }
    });

    return itemData;
  });

  const itemsMissingProductId = itemsWithVariants.filter(
    (item) => !item.productId,
  );
  if (itemsMissingProductId.length > 0) {
    toast.error(
      "Some products are missing product IDs. Please re-select the products.",
    );
    return;
  }

  const dataForSave = {
    bussinessUuid: finalBusinessUuid,
    isServices,
    isProducts,
    transactionAmount: (
      calculateTotalTransactionAmount(values) -
      calculateTotalSubscriptionSaving(productSections)
    ).toFixed(2),
    additionalFee: additionalFee,
    additionalDiscount: additionalDiscount,
    ...rem,
    subscriptionDisc:
      calculateTotalSubscriptionSaving(productSections).toFixed(2),
    items: JSON.stringify(itemsWithVariants),
    orderCouponName: appliedCouponType === "ORDER" ? appliedOrderCoupon : "",
    orderCouponDiscount:
      appliedCouponType === "ORDER" ? orderCouponDiscount : 0,
    couponType: appliedCouponType || "",
    deliveryFee,
    totalProfit: calculateTotalProfit(),
    igst: igst,
    cgst: cgst,
    sgst: sgst,
    cess: cess,
    export_sale,
    sez,
    advancePayment: advanceAmount,
    moreAdvancePayment,
    includingTax: includingTax,
  };

  if (!item && values.paymentMode === SCANNER_PAYMENT_OPTION) {
    setSaleIsLoading(true);
    let payment;
    try {
      const payable = Number(dataForSave.transactionAmount);
      if (!(payable > 0)) {
        setSaleIsLoading(false);
        toast.error("Amount to pay must be greater than 0");
        return;
      }
      setSaleIsLoading(false);
      payment = await collectSalePayment({
        businessUuid: finalBusinessUuid,
        amount: payable,
        customer: {
          name: values.customerName || dataForSave.customerName,
          phone: values.mobile || dataForSave.mobile,
        },
        businessName: business?.businessName,
      });
    } catch (error) {
      setSaleIsLoading(false);
      if (error?.message !== "CANCELLED") {
        toast.error(
          error?.response?.data?.message || error?.message || "Payment failed",
        );
      }
      return;
    }
    setSaleIsLoading(true);
    try {
      const res = await createSale(
        finalBusinessUuid,
        {
          ...dataForSave,
          paymentMode: "UPI",
          remainingTransactionAmount: 0,
        },
        { deferInvoiceWhatsApp: true },
      );
      if (res?.status === 201) {
        handleQrPaidSale(res.data, {
          values,
          itemsWithVariants,
          dataForSave,
          resetForm,
        });
      } else {
        toast.error(
          `Payment received (ref ${
            payment?.paymentId || "n/a"
          }) but the sale could not be created. Please contact support.`,
        );
      }
    } catch (error) {
      toast.error(
        `Payment received (ref ${
          payment?.paymentId || "n/a"
        }) but the sale could not be created: ${error.message}`,
      );
    } finally {
      setSaleIsLoading(false);
    }
    return;
  }

  if (item) {
    setSaleIsLoading(true);
    try {
      const { sellUuid } = item;

      const res = await updateSaleService(
        finalBusinessUuid,
        sellUuid,
        dataForSave,
      );
      setSaleIsLoading(false);
      if (res.status === 200) {
        if (appliedOrderCoupon) {
          await increaseCouponUsage(finalBusinessUuid, {
            couponName: appliedOrderCoupon,
          });
        }
        toast.success("Updated successfully !");
        // ✅ Redirect back to Sale.js datatable
        goToSaleList();
      } else if (res.status === 400 || res.status === 404) {
        toast.error(res.data?.message || "Update failed");
      } else {
        toast.error("Something went wrong!");
      }
    } catch (error) {
      setSaleIsLoading(false);
      console.error("Update error:", error);
      toast.error("Update failed: " + (error.message || "Unknown error"));
    }
  } else {
    setSaleIsLoading(true);
    try {
      let res = await createSale(finalBusinessUuid, dataForSave, {
        deferInvoiceWhatsApp: true,
      });
      setSaleIsLoading(false);

      if (res?.status === 201) {
        toast.success("Created successfully !");
        addSale(res.data);
        printSaleReceipt({
          businessName: business?.businessName || res.data?.businessName,
          business,
          sale: res.data,
          items: itemsWithVariants,
          taxes: { cgst, sgst, igst, cess },
          values: {
            ...values,
            transactionAmount: dataForSave.transactionAmount,
          },
        });
        resetForm?.();
        if (res.data?.sellUuid) queueInvoiceAutoShare(res.data);
        // ✅ Redirect back to Sale.js datatable
        goToSaleList();
      } else if (res.status === 400 || res.status === 404) {
        console.log("error", res);
      } else {
        toast.error("Something Went wrong!");
      }
    } catch (error) {
      setSaleIsLoading(false);
      toast.error("Creation failed: " + (error.message || "Unknown error"));
    }
  }
};

const handleQrPaid = (sale) => {
  const ctx = qrSaleContextRef.current;
  setQrSession(null);
  handleQrPaidSale(sale, ctx);
};

const handleQrPaidSale = (sale, ctx) => {
  if (!ctx || !sale) return;
  toast.success("Payment received. Sale created!");
  addSale(sale);
  printSaleReceipt({
    businessName: business?.businessName || sale?.businessName,
    business,
    sale,
    items: ctx.itemsWithVariants,
    taxes: { cgst, sgst, igst, cess },
    values: {
      ...ctx.values,
      transactionAmount: ctx.dataForSave.transactionAmount,
    },
  });
  ctx.resetForm?.();
  if (sale?.sellUuid) queueInvoiceAutoShare(sale);
  qrSaleContextRef.current = null;
  // ✅ Redirect back to Sale.js datatable
  goToSaleList();
};
  const handleExport = (export_sale) => {
    setExport_sale(export_sale);
    setSez(false);
    setTimeout(() => {
      const sectionCopy = [...productSections];
      sectionCopy.forEach((_, index) => {
        calculateFinalPrice(index, sectionCopy);
      });
    }, 100);
  };
  const handleSez = (sez) => {
    setSez(sez);
    setExport_sale(false);
    setTimeout(() => {
      const sectionCopy = [...productSections];
      sectionCopy.forEach((_, index) => {
        calculateFinalPrice(index, sectionCopy);
      });
    }, 100);
  };

  const handleIsProduct = (isProducts) => {
    if (productSections.length > 0 && productSections[0].productName) {
      toast.error("Cannot switch the section after select the item");
      return;
    }
    setIsProducts(!isProducts);
    setIsServices(false);
  };

  const validateStock = (selectedProducts, allProducts) => {
    return !selectedProducts.some((selectedProduct) => {
      const matchingProduct = allProducts.find(
        (product) => product.productId === selectedProduct.productId,
      );

      if (!matchingProduct) {
        toast.error(`Product not found: ${selectedProduct.productName}`);
        return true;
      }
      if (Number(selectedProduct.quantity) >= matchingProduct.quantity) {
        toast.error(
          `Insufficient stock for ${selectedProduct.productName}. Available: ${matchingProduct.quantity}, Requested: ${selectedProduct.quantity}`,
        );
        return true;
      }

      return false;
    });
  };

  const handleIsService = (isServices) => {
    if (productSections.length > 0 && productSections[0].productName) {
      toast.error("Cannot switch the section after select the item");
      return;
    }
    setIsServices(!isServices);
    setIsProducts(false);
  };

  const handleQuantityChange = (index, increment) => {
    setProductSections((prevSections) => {
      const newSections = [...prevSections];
      const section = { ...newSections[index] };

      if (section.hasVariants && !section.variantId) {
        toast.error("Please select a variant first");
        return prevSections;
      }

      // const newQuantity = Math.max(Number(section.quantity) + increment, 0);
      const newQuantity = Math.max(roundQty(toQty(section.quantity) + increment), 0);

      if (section.hasVariants && section.variantId && section.variantStock) {
        if (newQuantity > section.variantStock) {
          toast.error(
            `Only ${section.variantStock} units available for this variant`,
          );
          return prevSections;
        }
      }

      section.quantity = newQuantity;

      if (
        section.bulkPriceEligible &&
        Array.isArray(section.bulkPrice) &&
        section.bulkPrice.length > 0
      ) {
        const sortedBulkPrices = [...section.bulkPrice].sort(
          (a, b) => Number(a.quantity) - Number(b.quantity),
        );

        let matchedBulk = null;
        for (const bp of sortedBulkPrices) {
          if (
            Number(section.quantity) >= Number(bp.quantity) &&
            section.unitSize == bp.unit
          ) {
            matchedBulk = bp;
          }
        }

        if (matchedBulk) {
          section.salePrice = matchedBulk.price;
        }
      }

      const salePrice = parseFloat(section.salePrice) || 0;
      // const quantity = parseInt(section.quantity) || 1;
      const quantity = toQty(section.quantity);
      const discount = parseFloat(section.discount) || 0;
      const discountedPrice = salePrice * (1 - discount / 100);
      const igst = parseFloat(section.igst) || 0;
      const cgst = parseFloat(section.cgst) || 0;
      const sgst = parseFloat(section.sgst_utgst) || 0;
      const cess = parseFloat(section.cess) || 0;

      const isTaxExempt =
        export_sale === true || sez === true || showGST === false;
      const isSameState = intraState === false;

      let finalPrice = discountedPrice;

      if (!isTaxExempt) {
        if (isSameState) {
          finalPrice += (discountedPrice * (cgst + sgst + cess)) / 100;
        } else {
          finalPrice += (discountedPrice * (igst + cess)) / 100;
        }
      }

      section.finalPrice = Math.ceil(finalPrice * quantity);
      newSections[index] = section;
      return newSections;
    });
  };

  const handleAddDate = (startDate, endDate, occurrence = 0, setFieldValue) => {
    const updatedProductSections = [...productSections];
    let newProductSection = updatedProductSections[activeIndex];
    newProductSection["startDate"] = startDate;
    newProductSection["endDate"] = endDate;
    newProductSection["occurence"] = occurrence;

    if (startDate) {
      setFieldValue("saleDate", startDate);
    }
    setProductSections(updatedProductSections);
  };
    const handleSaleUnitChange = (index, type) => {
    setProductSections((prev) => {
      const next = [...prev];
      const section = { ...next[index] };
      if ((section.saleUnitType || "main") === type) return prev;

      if (!section.baseUnitSize) {
        section.baseUnitSize = section.unitSize;
      }

      const conv = Number(section.conversionQty) || 1;
      const price = parseFloat(section.salePrice) || 0;

      section.saleUnitType = type;
      section.unitSize =
        type === "additional" ? section.additionalUnit : section.baseUnitSize;
      section.salePrice =
        type === "additional"
          ? String(Math.round((price / conv) * 100) / 100)
          : String(Math.round(price * conv * 100) / 100);

      next[index] = section;
      setTimeout(() => calculateFinalPrice(index, next), 10);
      return next;
    });
  };

  // const handleSaleUnitChange = (index, type) => {
  //   setProductSections((prev) => {
  //     const next = [...prev];
  //     const section = { ...next[index] };
  //     if ((section.saleUnitType || "main") === type) return prev;
  //     const conv = Number(section.conversionQty) || 1;
  //     const price = parseFloat(section.salePrice) || 0;
  //     section.saleUnitType = type;
  //     section.unitSize =
  //       type === "additional"
  //         ? section.additionalUnit
  //         : section.baseUnitSize || section.unitSize;
  //     section.salePrice =
  //       type === "additional"
  //         ? String(Math.round((price / conv) * 100) / 100)
  //         : String(Math.round(price * conv * 100) / 100);
  //     next[index] = section;
  //     setTimeout(() => calculateFinalPrice(index, next), 10);
  //     return next;
  //   });
  // };

  const handleInputChange = (index, field, value) => {
    if (field === "subscriptionType" && value !== "") {
      setActiveIndex(index);
      setShowPopup(true);
    }

    setProductSections((prevSections) => {
      const newSections = [...prevSections];
      const section = { ...newSections[index] };

      if (field === "discount") {
        section[field] = evaluateExpression(value);
      } else {
        section[field] = value;
      }

      if (
        section.bulkPriceEligible &&
        Array.isArray(section.bulkPrice) &&
        section.bulkPrice.length > 0 &&
        (field === "quantity" || field === "salePrice" || field === "unitSize")
      ) {
        const sortedBulkPrices = [...section.bulkPrice].sort(
          (a, b) => Number(a.quantity) - Number(b.quantity),
        );

        let matchedBulk = null;
        for (const bp of sortedBulkPrices) {
          if (
            Number(section.quantity) >= Number(bp.quantity) &&
            section.unitSize == bp.unit
          ) {
            matchedBulk = bp;
          }
        }

        if (matchedBulk) {
          section.salePrice = matchedBulk.price;
        } else {
          section.salePrice = section.purchasePrice || section.salePrice;
        }
      }

      newSections[index] = section;

      if (
        [
          "salePrice",
          "discount",
          "discountUnit",
          "igst",
          "cgst",
          "sgst_utgst",
          "cess",
          "quantity",
          "unitSize",
        ].includes(field)
      ) {
        setTimeout(() => {
          calculateFinalPrice(index, newSections);
        }, 10);
      }

      return newSections;
    });
  };

  const handleSelectProduct = (selectedProduct, index) => {
    if (selectedProduct.hasVariants && selectedProduct.variants?.length > 0) {
      setSelectedProductForVariant(selectedProduct);
      setSelectedProductIndex(index);
      setShowVariantModal(true);
      setSearchResults([]);
      return;
    }

    if (selectedProduct.quantity === 0 || selectedProduct.quantity === "0") {
      toast.error(
        "Out of Stock",
        `${selectedProduct.productName || selectedProduct.serviceName} is out of stock.`,
      );
      return;
    }

    if (selectedProduct?.expDate) {
      const expDate = moment(selectedProduct.expDate, "DD-MM-YYYY");
      const today = moment().startOf("day");
      if (expDate.isBefore(today)) {
        toast.error(
          `${selectedProduct.productName || selectedProduct.serviceName} has expired.`,
        );
        return;
      }
    }

    const {
      productName,
      salePrice,
      productId,
      subscriptionEligible,
      bulkPriceEligible,
      purchasePrice = 0,
      subscription,
      serviceId,
      showReturn,
      returnPeriod,
      quantity,
      discountUnit,
      taxIncluded,
      ...rem
    } = selectedProduct;

    const finalDis = calculateDiscount(selectedProduct);
    let finalPrice = salePrice - finalDis;
    const igst = parseFloat(selectedProduct.igst) || 0;
    const cgst = parseFloat(selectedProduct.cgst) || 0;
    const sgst = parseFloat(selectedProduct.sgst_utgst) || 0;
    const cess = parseFloat(selectedProduct.cess) || 0;

    const isTaxExempt =
      export_sale === true || sez === true || showGST === false;
    const isSameState = intraState === false;

    if (!includingTax && !taxIncluded && !isTaxExempt) {
      if (isSameState) {
        finalPrice += (finalPrice * (cgst + sgst + cess)) / 100;
      } else {
        finalPrice += (finalPrice * (igst + cess)) / 100;
      }
    }

    const updatedProductSections = [...productSections];

    updatedProductSections[index] = {
      ...updatedProductSections[index],
      productName:
        isServices === true ? selectedProduct?.serviceName : productName,
      salePrice,
      quantity: 1,
      finalPrice: Math.ceil(finalPrice),
      serviceId,
      discount: finalDis,
      discountUnit: discountUnit,
      igst,
      cgst,
      sgst_utgst: sgst,
      cess,
      productId,
      subscriptionEligible,
      bulkPriceEligible,
      purchasePrice: purchasePrice
        ? purchasePrice
        : selectedProduct?.serviceCost,
      subscription,
      subscriptionOption: optionsForSubscription(subscription),
      showReturn,
      returnPeriod,
      taxIncluded: taxIncluded || false,
      hasVariants: selectedProduct.hasVariants || false,
      variants: selectedProduct.variants || [],
       baseUnitSize: selectedProduct.unitSize,
        saleUnitType: "main",  
      ...rem,
    };

    setProductSections(updatedProductSections);
    setSearchResults([]);
    setActiveIndex(null);
  };

  const calculateFinalPrice = (
    index,
    sections = productSections,
    overWriteIntraState = false,
  ) => {
    const toNum = (v) => {
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    };

    const toCents = (v) => Math.round(toNum(v) * 100);
    const centsToRupees = (c) => +(c / 100);

    const updatedSections = (sections || []).map((s) => ({ ...s }));

    const productBaseCents = updatedSections.map((section) => {
      const salePrice = toNum(section.salePrice);
      let base = salePrice;

      if (visibleFields.discount) {
        const d = toNum(section.discount);
        base -= section.discountUnit === "%" ? (salePrice * d) / 100 : d;
      }

      // base *= section.quantity || 1;
      base *= toQty(section.quantity);
      return toCents(base);
    });

    let currentBases = [...productBaseCents];

    if (isProportional) {
      const totalBase = productBaseCents.reduce((s, v) => s + v, 0);
      const proportionalShares = productBaseCents.map((b) =>
        totalBase > 0 ? b / totalBase : 0,
      );

      (additionalDiscount || []).forEach((item) => {
        if (!item?.amount) return;
        const amount = toNum(item.amount);

        if (item.type === "₹") {
          const totalFlatCents = toCents(amount);
          let distributed = 0;

          proportionalShares.forEach((p, i, arr) => {
            let alloc;
            if (i === arr.length - 1) {
              alloc = totalFlatCents - distributed;
            } else {
              alloc = Math.round(totalFlatCents * p);
            }
            distributed += alloc;
            currentBases[i] -= alloc;
          });
        } else if (item.type === "%") {
          proportionalShares.forEach((p, i) => {
            const discount = Math.round(
              (productBaseCents[i] * amount * p) / 100,
            );
            currentBases[i] -= discount;
          });
        }
      });

      (additionalFee || []).forEach((item) => {
        if (!item?.amount) return;
        const amount = toNum(item.amount);

        if (item.type === "₹") {
          const totalFlatCents = toCents(amount);
          let distributed = 0;

          proportionalShares.forEach((p, i, arr) => {
            let alloc;
            if (i === arr.length - 1) {
              alloc = totalFlatCents - distributed;
            } else {
              alloc = Math.round(totalFlatCents * p);
            }
            distributed += alloc;
            currentBases[i] += alloc;
          });
        } else if (item.type === "%") {
          proportionalShares.forEach((p, i) => {
            const fee = Math.round((productBaseCents[i] * amount * p) / 100);
            currentBases[i] += fee;
          });
        }
      });
    }

    const isTaxExempt = export_sale || sez;
    const isSameState =
      overWriteIntraState !== false ? overWriteIntraState : intraState;

    let totalFinalAmountCents = 0;

    const productsWithProportional = updatedSections.map((section, i) => {
      let baseCents = currentBases[i];
      let finalCents = baseCents;

      const shouldCalculateTax =
        !includingTax && !section.taxIncluded && !isTaxExempt && showGST;

      if (shouldCalculateTax) {
        let taxPercent = 0;

        if (!isSameState) {
          const cgst = visibleFields.cgst ? toNum(section.cgst) : 0;
          const sgst = visibleFields.sgst ? toNum(section.sgst_utgst) : 0;
          const cess = visibleFields.cess ? toNum(section.cess) : 0;
          taxPercent = cgst + sgst + cess;
        } else {
          const igst = visibleFields.igst ? toNum(section.igst) : 0;
          const cess = visibleFields.cess ? toNum(section.cess) : 0;
          taxPercent = igst + cess;
        }

        finalCents += (baseCents * taxPercent) / 100;
      }

      totalFinalAmountCents += finalCents;

      return {
        ...section,
        base: centsToRupees(productBaseCents[i]),
        newBase: centsToRupees(baseCents),
        finalPrice: centsToRupees(finalCents).toFixed(2),
      };
    });

    let totalFinalAmount = centsToRupees(totalFinalAmountCents);
    totalFinalAmount = Math.round(totalFinalAmount * 100) / 100;
    if (appliedOrderCoupon && appliedCouponType === "PRODUCT") {
      const totalProducts = productsWithProportional.length;

      if (totalProducts > 0) {
        const perProductDiscount = orderCouponDiscount / totalProducts;

        productsWithProportional.forEach((p) => {
          const old = parseFloat(p.finalPrice) || 0;
          p.finalPrice = Math.max(old - perProductDiscount, 0).toFixed(2);
        });
      }
    }
    // setProductSections(productsWithProportional);
        setProductSections((prev) => {
      if (prev.length !== productsWithProportional.length) return prev;
      return prev.map((row, i) => {
        const snap = updatedSections[i];
        // agar beech me row badal gaya (naya scan / quantity), to purana price mat likho
        if (
          !snap ||
          row.productId !== snap.productId ||
          row.variantId !== snap.variantId ||
          row.quantity !== snap.quantity ||
          row.salePrice !== snap.salePrice
        ) {
          return row;
        }
        return {
          ...row,
          base: productsWithProportional[i].base,
          newBase: productsWithProportional[i].newBase,
          finalPrice: productsWithProportional[i].finalPrice,
        };
      });
    });
    return totalFinalAmount.toFixed(2);
  };
// ========== AUTO-FILL CUSTOMER ON FULL MOBILE ENTRY ==========
const handleMobileBlur = (phone, setFieldValue) => {
  if (!phone) return;

  const normalized = normalizeMobile(phone);
  // Only auto-fill if a complete (10-digit for India) number is entered
  if (normalized.length < 10) return;

  const existing = customers.find(
    (c) => normalizeMobile(c.customer_mobile) === normalized,
  );

  if (existing) {
    setFieldValue("mobile", existing.customer_mobile || phone);
    setDisableName(true);
    setCustomerVoiceInput(existing.name || "");
    setFieldValue("customerName", existing.name || "");
    setFieldValue("state", existing.state || "");
    setFieldValue("address", existing.customer_address || "");
    setFieldValue("gstNo", existing.gstIN || "");
    setFilteredCustomers([]);

    toast.info(
      `Existing customer "${existing.name}" auto-filled for this mobile number.`,
    );
  }
};
  const isDisabled = readOnly || disableAllInteractions;

    // ================= BARCODE SCANNER =================
  const scanInputRef = useRef(null);
  const productSectionsRef = useRef(productSections);
  productSectionsRef.current = productSections;
  const lastScanRef = useRef({ code: "", time: 0 });
  const [lastScan, setLastScan] = useState(null);

  const barcodeIndex = useMemo(() => {
    const map = new Map();
    (products || []).forEach((p) => {
      getCodes(p, PRODUCT_CODE_KEYS).forEach((c) => {
        if (!map.has(c)) map.set(c, { product: p, variant: null });
      });
      (p?.variants || []).forEach((v) => {
        getCodes(v, VARIANT_CODE_KEYS).forEach((c) => {
          map.set(c, { product: p, variant: v }); 
        });
      });
    });
    return map;
  }, [products]);

  const scanFail = (msg) => {
    setLastScan({ ok: false, msg });
    toast.error(msg, { toastId: "scan-error" });
    playBeep(false);
  };
  const scanOk = (msg) => {
    setLastScan({ ok: true, msg });
    playBeep(true);
  };

  const buildVariantRow = (product, variant) => {
    const [base] = transformProducts([product], false);
    if (!base) return null;
    return {
      ...base,
      hasVariants: true,
      variantId: variant.variantId,
      variantName: variant.variantName,
      variantDetails: { ...variant, productId: product.productId },
      variantAttributes: variant.attributes || [],
      variantSku: variant.sku || "",
      variantStock: variant.quantity || 0,
      salePrice: variant.salePrice || base.salePrice,
      purchasePrice: variant.purchasePrice || base.purchasePrice,
      batchNumber: variant.batchNumber || base.batchNumber,
      mfgDate: variant.mfgDate || base.mfgDate,
      expDate: variant.expDate || base.expDate,
    };
  };

  const handleBarcodeScan = (rawCode) => {
    const display = String(rawCode || "").trim();
    const code = normCode(display);
    if (!code) return;

    const now = Date.now();
    if (lastScanRef.current.code === code && now - lastScanRef.current.time < 50) return;
    lastScanRef.current = { code, time: now };

    if (isOpen || isOpenFullPayment || isOpenPayPartial || showVariantModal || showPopup) {
      return scanFail("Close the currently open popup before scanning.");
    }
    if (isServices) return scanFail("The scanner is only for products.");
    if (barcodeIndex.size === 0) {
      return scanFail("Products failed to load, or the products don’t have an EAN/SKU.");
    }

    const hit = barcodeIndex.get(code);
    if (!hit) return scanFail(`Barcode "${display}" Not found in inventory.`);

    const { product, variant } = hit;
    const name = product.productName;

    if (!variant && product.hasVariants && product.variants?.length > 0) {
      return scanFail(`${name}:Scan the variant barcode.`);
    }

    const label = variant ? `${name} (${variant.variantName})` : name;
    const current = productSectionsRef.current;

    const stockSource = variant ? variant.quantity : product.quantity;
    const hasStock =
      stockSource !== undefined && stockSource !== null && stockSource !== "";
    if (hasStock && Number(stockSource) <= 0) {
      return scanFail(`${label} is out of stock `);
    }

    const existingIdx = current.findIndex(
      (s) =>
        s.productId === product.productId &&
        (variant ? s.variantId === variant.variantId : !s.variantId),
    );

    if (existingIdx >= 0) {
      const nextQty = Number(current[existingIdx].quantity || 0) + 1;
      if (hasStock && nextQty > Number(stockSource)) {
        return scanFail(`${label}: sirf ${stockSource} Stock is available.`);
      }
      productSectionsRef.current = current.map((s, i) =>
        i === existingIdx ? { ...s, quantity: nextQty } : s,
      );
      handleQuantityChange(existingIdx, 1);
      return scanOk(`${label} × ${nextQty}`);
    }

    const row = variant
      ? buildVariantRow(product, variant)
      : transformProducts([product], false)[0]; 
    if (!row) {
      setLastScan({ ok: false, msg: `${label} Expired.` });
      playBeep(false);
      return;
    }

    const kept = current.filter((s) => s.productName); 
    const next = [...kept, row];
    productSectionsRef.current = next;
    setProductSections(next);

    if (kept.length === 0) {
      setVisibleFields((prev) => ({
        ...prev,
        subscription: subscriptionEnabled,
        discount: discountEnabled,
        disUnit: discountEnabled,
        igst: true,
        cgst: true,
        sgst: true,
        cess: true,
      }));
    }

    scanOk(`${label} added`);
  };

  useEffect(() => {
    if (isDisabled) return;
    const onKeyDown = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (!e.key || e.key.length !== 1) return;
      if (isOpen || isOpenFullPayment || isOpenPayPartial || showVariantModal || showPopup) return;
      const el = document.activeElement;
      const tag = el?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el?.isContentEditable) return;
      scanInputRef.current?.focus();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isDisabled, isOpen, isOpenFullPayment, isOpenPayPartial, showVariantModal, showPopup]);

  useEffect(() => {
    if (isDisabled) return;
    if (!isOpen && !isOpenFullPayment && !isOpenPayPartial && !showVariantModal && !showPopup) {
      const t = setTimeout(() => scanInputRef.current?.focus(), 150);
      return () => clearTimeout(t);
    }
  }, [isDisabled, isOpen, isOpenFullPayment, isOpenPayPartial, showVariantModal, showPopup]);
  // ================= END BARCODE SCANNER =================
  const handleAddProductSection = () => {
    setProductSections((prevSections) => [
      ...prevSections,
      {
        productName: "",
        quantity: 1,
        subscriptionType: "",
        salePrice: "",
        discount: "",
        gstPercent: "",
        finalPrice: "",
        productId: "",
        purchasePrice: 0,
        status: "Active",
        subscription: [],
        subscriptionOption: [],
        listening: false,
        igst: 0,
        cgst: 0,
        sgst_utgst: 0,
        cess: 0,
        showReturn: false,
        returnPeriod: "",
        hasVariants: false,
        variantId: "",
        variantName: "",
        variantDetails: null,
        variantAttributes: [],
        variantSku: "",
        variantStock: 0,
      },
    ]);
  };

  const handleDeleteProductSection = (index) => {
    setProductSections((prevSections) => {
      if (prevSections.length <= 1) {
        toast.error("At least one item must remain");
        return prevSections;
      }

      const updatedSections = prevSections.filter((_, idx) => idx !== index);

      setTimeout(() => {
        updatedSections.forEach((_, i) => {
          calculateFinalPrice(i, updatedSections);
        });
      }, 0);

      return updatedSections;
    });
  };

  const calculateTotalSubscriptionSaving = (products) => {
    if (!visibleFields?.subscription) return 0;
    return products.reduce((totalSaving, product) => {
      const salePrice = parseFloat(product.salePrice);
      const { subscriptionType, subscription, quantity } = product;

      if (subscriptionType && subscription) {
        const selectedSubscription = subscription.find(
          (sub) => sub.frequency === subscriptionType,
        );

        if (!selectedSubscription) {
          return totalSaving;
        }
        const subscriptionDiscount = parseFloat(
          selectedSubscription.subscriptionDisc,
        );
        const discountUnit = selectedSubscription.disUnit || "%";
        let saving = 0;
        if (discountUnit === "₹") {
          saving = subscriptionDiscount;
        } else if (discountUnit === "%" || discountUnit === "") {
          saving = (subscriptionDiscount / 100) * salePrice;
        }
        return totalSaving + saving * quantity;
      }
      return totalSaving;
    }, 0);
  };

  const handleInputSearch = (e, index) => {
    const value = e.target ? e.target.value : e;
    setActiveIndex(index);
    if (value.length >= 3) {
      let filteredProducts;
      if (isServices === true) {
        filteredProducts = service.filter((product) =>
          product.serviceName.toLowerCase().includes(value.toLowerCase()),
        );
      } else {
        filteredProducts = products.filter((product) =>
          product.productName.toLowerCase().includes(value.toLowerCase()),
        );
      }
      setSearchResults(filteredProducts);
    } else {
      setSearchResults([]);
    }
  };

  const handleVoiceSearch = async (index) => {
    setActiveIndex(index);
    setListening(true);
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";
    recognition.onresult = async (event) => {
      const voiceInput = event.results[0][0].transcript;
      await handleInputChange(index, "productName", voiceInput);
      await handleInputSearch(voiceInput, index);
    };
    recognition.start();
    recognition.onend = () => {
      setListening(false);
      setActiveIndex(null);
    };
  };

  // ========== FIXED: voice search for customer name auto-fills mobile ==========
  const handleCustomerNameVoiceSearch = (setFieldValue) => {
    setActiveIndex(null);
    setListeningCustomerName(true);

    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";
    recognition.onresult = (event) => {
      const voiceInput = event.results[0][0].transcript;
      setCustomerVoiceInput(voiceInput);
      setFieldValue("customerName", voiceInput);

      // Auto-detect existing customer by name
      const existing = customers.find(
        (c) =>
          (c.name || "").toLowerCase().trim() ===
          voiceInput.toLowerCase().trim(),
      );
      if (existing) {
        setFieldValue("mobile", existing.customer_mobile);
        setDisableName(true);
      }
    };
    recognition.onaudioend = () => {
      setListeningCustomerName(false);
    };

    recognition.start();
  };

  const handlePrintReceipt = async (values) => {
    const productsWithVariants = productSections.filter(
      (section) => section.hasVariants && !section.variantId,
    );

    if (productsWithVariants.length > 0) {
      const productNames = productsWithVariants
        .map((p) => p.productName)
        .join(", ");
      toast.error(`Please select variants for: ${productNames}`);
      return;
    }

    const { transactionAmount, additionalFee, additionalDiscount, ...rem } =
      values;
    const dataForSave = {
      isServices,
      isProducts,
      transactionAmount: (
        calculateTotalTransactionAmount(values) -
        calculateTotalSubscriptionSaving(productSections)
      ).toFixed(2),
      additionalFee: additionalFee,
      additionalDiscount: additionalDiscount,
      ...rem,
      subscriptionDisc:
        calculateTotalSubscriptionSaving(productSections).toFixed(2),
      items: JSON.stringify(productSections),
      deliveryFee,
      totalProfit: calculateTotalProfit(),
      igst: igst,
      cgst: cgst,
      sgst: sgst,
      cess: cess,
      export_sale,
      sez,
      advancePayment: advanceAmount,
      includingTax: includingTax,
    };

    setSaleIsLoading(true);
    let res = await addEstimate(finalBusinessUuid, dataForSave);

    setSaleIsLoading(false);
    if (res.status === 201) {
      await close(res.data, true);
      toast.success("Created successfully !");
    } else {
      toast.error("Something Went wrong!");
    }
  };

  // ========== FIXED: handlePhoneVoiceSearch uses normalizeMobile ==========
  const handlePhoneVoiceSearch = (setFieldValue) => {
    setListeningMobile(true);
    const recognition = new window.webkitSpeechRecognition();
    recognition.lang = "en-US";
    recognition.onresult = (event) => {
      const voiceInput = event.results[0][0].transcript.replace(/\D/g, "");
      const normalized = normalizeMobile(voiceInput);

      if (normalized.length >= 6) {
        filterCustomers(normalized);
        setFieldValue("mobile", normalized);
      } else {
        setFilteredCustomers([]);
        setFieldValue("mobile", normalized);
      }

      const matchedName = findCustomerNameByMobile(normalized);
      setFieldValue("customerName", matchedName ? matchedName.name : "");
    };
    recognition.onend = () => {
      setListeningMobile(false);
    };
    recognition.start();
  };

  const extractStateName = (stj = "") => {
    const match = stj.match(/State - ([^,]+)/);
    return match ? match[1].trim() : "";
  };

  const verifyGST = async (gstNo, setFieldValue) => {
    try {
      const res = await verifyGSTService(gstNo);
      const gstData = res?.data?.data.data;
      if (!gstData) return;
      setFieldValue("address", gstData?.pradr?.adr || "");
      const stateName = extractStateName(gstData?.stj);
      const stateCode = STATE_CODE_MAP[stateName];
      if (stateCode) {
        setFieldValue("state", stateCode);
      }
    } catch (err) {
      console.error("GST Verify Error:", err);
    }
  };

  return (
    <>
      <TourGuide steps={SaleSteps} runTour={runTour} />

      <VariantSelectionModal
        isOpen={showVariantModal}
        onClose={() => setShowVariantModal(false)}
        product={selectedProductForVariant}
        onSelectVariant={handleVariantSelect}
        currentIndex={selectedProductIndex}
        businessUuid={finalBusinessUuid}
      />

      {!showInvoice ? (
        <Formik
         key={item?.sellUuid || "new-sale"}
          enableReinitialize={false}
          initialValues={{
            ...initialValuesForSale(item ? item : null, user),
            ...initialValues,
          }}
          validationSchema={salevalidationSchema()}
          onSubmit={onSubmit}
        >
          {(formik) => {
            const {
              errors,
              values,
              touched,
              handleBlur,
              handleChange,
              setFieldValue,
            } = formik;

            const handleFormikChange = (e) => {
              handleChange(e);

              if (e?.target?.name === "saleType") {
                setSaleTypes(e?.target?.value);
              }

              if (e?.target?.name?.startsWith("additionalDiscount")) {
                const path = e.target.name.split(".");
                const index = parseInt(path[1], 10);
                const key = path[2];

                setAdditionalDiscount((prev) => {
                  const updated = [...prev];

                  if (!updated[index]) {
                    updated[index] = { type: "%", amount: 0 };
                  }

                  updated[index][key] = e.target.value;

                  return updated;
                });
              }

              if (e?.target?.name?.startsWith("additionalFee")) {
                const path = e.target.name.split(".");
                const index = parseInt(path[1], 10);
                const key = path[2];

                setAdditionalFee((prev) => {
                  const updated = [...prev];

                  if (!updated[index]) {
                    updated[index] = { type: "%", amount: 0 };
                  }

                  updated[index][key] = e.target.value;

                  return updated;
                });
              }
            };

            const removeDiscount = (index) => {
              const updated = [...values.additionalDiscount];
              updated.splice(index, 1);

              setFieldValue("additionalDiscount", updated);
              setAdditionalDiscount(updated);
            };

            const addDiscount = () => {
              const updated = [
                ...values.additionalDiscount,
                { label: "Discount", amount: 0, type: "%" },
              ];

              setFieldValue("additionalDiscount", updated);
              setAdditionalDiscount(updated);
            };

            const removeFee = (index) => {
              const updated = [...values.additionalFee];
              updated.splice(index, 1);

              setFieldValue("additionalFee", updated);
              setAdditionalFee(updated);
            };

            const addFee = () => {
              const updated = [
                ...values.additionalFee,
                { label: "Fee", amount: 0, type: "%" },
              ];

              setFieldValue("additionalFee", updated);
              setAdditionalFee(updated);
            };

            updateTaxStates(values);

            const handleToggle = () => {
              setIntraState((prev) => {
                const newValue = !prev;

                setFieldValue("intraState", newValue);

                setTimeout(() => {
                  const sectionCopy = [...productSections];
                  sectionCopy.forEach((_, index) => {
                    calculateFinalPrice(index, sectionCopy, !newValue);
                  });
                }, 100);

                return newValue;
              });
            };

            const handleDeliveryFeeChange = (e) => {
              const value = e.target.value;

              setFieldValue("deliveryFee", value);

              let newAdditionalFee = [...values.additionalFee];
              if (newAdditionalFee.length === 0) {
                newAdditionalFee.push({ label: "Delivery Fee", amount: value });
              } else {
                newAdditionalFee[0] = { label: "Delivery Fee", amount: value };
              }
              setFieldValue("additionalFee", newAdditionalFee);
            };

            return (
              <Form>
                <div className="bg-white dark:bg-gray-900 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
                  <div className="border border-2 border-bold rounded p-6 bg-white border-gray-300 slider-box dark:bg-[#170f2a] dark:border-gray-300 dark:text-white">
                    <button
                      type="button"
                      onClick={() => navigate(-1)}
                      className="flex items-center justify-center w-11 h-11 mb-3 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-slate-800 hover:bg-blue-50 dark:hover:bg-slate-700 transition-all shadow-sm"
                    >
                      <FiArrowLeft className="text-xl text-gray-700 dark:text-white" />
                    </button>
                    {isPrinterSupported() && (
                      <div className="mb-3 flex gap-2 text-xs">
                        {["serial", "usb"].map((kind) => (
                          <button
                            key={kind}
                            type="button"
                            onClick={() =>
                              connectPrinter(kind)
                                .then(() => toast.success("Printer connected"))
                                .catch((e) => toast.error(e.message))
                            }
                            className="px-3 py-1 rounded border border-gray-300 hover:bg-blue-50"
                          >
                            Connect printer ({kind === "serial" ? "Bluetooth/COM" : "USB"})
                          </button>
                        ))}
                      </div>
                    )}
                    <div className="bg-gray-50 border border-gray-200 dark:border-gray-700 rounded-lg p-4 dark:bg-[#170f2a] shadow-sm">
                      <div className=" border-b border-gray-100 dark:border-gray-800">
                        <div className="flex items-center justify-between mb-1">
                          <div className="flex items-center gap-3">
                            <div className="p-2 bg-gradient-to-br from-blue-100 to-blue-50 dark:from-blue-900/30 dark:to-blue-800/30 rounded-xl">
                              <FiSettings className="text-blue-600 dark:text-blue-400 text-xl" />
                            </div>
                            <div>
                              <h3 className="text-sm font-semibold text-gray-900 dark:text-white">
                                Transaction Settings
                              </h3>
                            </div>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
                            <div className="flex items-center justify-between mb-4">
                              <div className="flex items-center space-x-3">
                                <div className="relative">
                                  <button
                                    id="showGST"
                                    type="button"
                                    onClick={async () => {
                                      setShowgst(!showGST);
                                      await setFieldValue(
                                        "showGST",
                                        !values.showGST,
                                      );
                                      await setTimeout(() => {
                                        const sectionCopy = [
                                          ...productSections,
                                        ];
                                        sectionCopy.forEach((_, index) => {
                                          calculateFinalPrice(
                                            index,
                                            sectionCopy,
                                          );
                                        });
                                      }, 12);
                                    }}
                                    className={`w-12 h-6 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-300 ${
                                      values.showGST
                                        ? "bg-green-500 hover:bg-green-600"
                                        : "bg-gray-300 hover:bg-gray-400 dark:bg-gray-600"
                                    }`}
                                  >
                                    <span
                                      className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                                        values.showGST
                                          ? "translate-x-6"
                                          : "translate-x-0"
                                      }`}
                                    />
                                  </button>
                                </div>
                                <label
                                  htmlFor="showGST"
                                  className="text-sm font-medium text-gray-700 dark:text-gray-300"
                                >
                                  {t("FORM.GST")}
                                </label>
                              </div>

                              <div className="ml-4">
                                <ToggleButton
                                  value={values.intraState}
                                  onToggle={handleToggle}
                                  activeColor="bg-green-500 hover:bg-green-600"
                                  inactiveColor="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600"
                                  label={t("FORM.INTERSTATE")}
                                  secondaryLabel={t("REPORT.INTRASTATE")}
                                  secondaryPosition="left"
                                  className="text-xs font-medium"
                                />
                              </div>
                            </div>

                            {values.showGST && (
                              <div className="mt-4 space-y-4">
                                <div className="flex gap-2">
                                  <div className="flex-1">
                                    <CustomField
                                      type="text"
                                      name="gstNo"
                                      label={t("FORM.GST_NO")}
                                      placeholder="Enter 15-digit GST number"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values.gstNo}
                                      touched={touched.gstNo}
                                      className="w-full"
                                      size="small"
                                      inputProps={{ maxLength: 15 }}
                                    />
                                  </div>
                                  <div className="flex items-end">
                                    <button
                                      type="button"
                                      onClick={() => {
                                        verifyGST(values.gstNo, setFieldValue);
                                      }}
                                      disabled={values.gstNo?.length !== 15}
                                      className={`h-8 px-4 rounded-md font-medium transition-colors ${
                                        values.gstNo?.length === 15
                                          ? "bg-blue-600 hover:bg-blue-700 text-white shadow-sm"
                                          : "bg-gray-100 dark:bg-gray-700 text-gray-400 cursor-not-allowed"
                                      }`}
                                    >
                                      Verify
                                    </button>
                                  </div>
                                </div>
                                <p className="text-xs text-gray-500 dark:text-gray-400">
                                  {t("FORM.ENTER_HELPERTEXT")}
                                </p>
                              </div>
                            )}
                          </div>

                          {saleSettings?.export !== false && (
                          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
                            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">
                              Sale Options
                            </h3>
                            <div className="space-y-3">
                              <div className="flex items-center space-x-2">
                                <Field
                                  as={Checkbox}
                                  name="export_sale"
                                  checked={export_sale}
                                  onChange={() => handleExport(!export_sale)}
                                  className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                />
                                <span className="text-sm text-gray-700 dark:text-gray-300">
                                  {t("FORM.EXPORT")}
                                </span>
                              </div>

                              <div className="flex items-center space-x-2">
                                <Field
                                  as={Checkbox}
                                  name="sez"
                                  checked={sez}
                                  onChange={() => handleSez(!sez)}
                                  className="h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                />
                                <span className="text-sm text-gray-700 dark:text-gray-300">
                                  {t("FORM.SEZ")}
                                </span>
                              </div>
                            </div>
                          </div>
                          )}

                          <div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
                            <CustomField
                              type="select"
                              name="customer_type"
                              label={t("FORM.CUSTOMER_TYPE")}
                              placeholder="Select Customer Type"
                              options={optionsForCustomertype}
                              setFieldValue={setFieldValue}
                              handleChange={handleChange}
                              value={values.customer_type}
                              className="w-full"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="bg-gray-50 border border-gray-200 dark:border-gray-700 rounded-lg p-4 mb-6 mt-4 dark:bg-[#170f2a] shadow-sm">
                        <div className="flex justify-between items-center mb-4">
                          <div className="flex items-center gap-3">
                            <div className="p-2 bg-gradient-to-br from-orange-50 to-orange-50 dark:from-orange-900/20 dark:to-orange-900/20 rounded-xl">
                              <svg
                                className="w-5 h-5 text-orange-600 dark:text-blue-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                />
                              </svg>
                            </div>
                            <div>
                              <p className="text-sm text-blue-700 font-semibold dark:text-gray-400">
                                Enter customer details and preferences
                              </p>
                            </div>
                          </div>
                          <button
                            type="button"
                            onClick={() =>
                              setShowAdditionalFields(!showAdditionalFields)
                            }
                            className={`
                              relative
                              px-3 py-1.5
                              bg-blue-50 hover:bg-blue-100
                              dark:bg-gray-700 dark:hover:bg-gray-600
                              text-blue-600 dark:text-blue-400
                              hover:text-blue-800 dark:hover:text-blue-300
                              rounded-lg
                              border border-blue-200 dark:border-gray-600
                              transition-all duration-200
                              flex items-center justify-center
                              group
                              text-sm
                              shadow-sm hover:shadow-md
                              ml-auto
                            `}
                          >
                            {showAdditionalFields ? (
                              <>
                                <FiChevronUp className="mr-1 transition-transform duration-200" />
                                <span>Hide Fields</span>
                              </>
                            ) : (
                              <>
                                <FiChevronDown className="mr-1 transition-transform duration-200" />
                                <span>More Fields</span>
                              </>
                            )}
                            <span
                              className={`
                                absolute -bottom-1 left-0 right-0
                                h-0.3 bg-blue-200 dark:bg-blue-800
                                transition-all duration-300
                                ${showAdditionalFields ? "scale-x-100" : "scale-x-0"}
                              `}
                            ></span>
                          </button>
                        </div>

                        <div className="grid grid-cols-4 gap-4 bg-white border rounded-lg p-4 dark:bg-[#020617]">
                          <div className="col-span-1 relative">
                           <CustomPhoneNumberField
  name="mobile"
  countryCode={values.countryCode}
  label="Mobile *"
  value={values.mobile}
  onBlur={(e) => {
    handleBlur(e);
    handleMobileBlur(e.target.value, setFieldValue); // <-- ADD THIS
  }}
  onChange={handleChange}
  error={errors.mobile}
  touched={touched.mobile}
  handleInputChange={(phone, country, setFieldValue) => {
    handleMobileInputChange(phone, country, setFieldValue);
    // Auto-fill as soon as a full number is typed
    const normalized = normalizeMobile(phone);
    if (normalized.length >= 10) {
      handleMobileBlur(phone, setFieldValue);
    }
  }}
/>
                            <button
                              type="button"
                              onClick={() =>
                                handlePhoneVoiceSearch(setFieldValue)
                              }
                              className="absolute left-full ml-2 mt-1.5"
                            >
                              <div className="relative w-6 h-7 bg-white flex justify-center items-center absolute bottom-1 right-10 dark:bg-gray-800">
                                <i
                                  className={`text-xl ${
                                    listeningMobile
                                      ? "text-green-400"
                                      : "text-blue-600"
                                  }`}
                                >
                                  <HiOutlineMicrophone />
                                </i>
                              </div>
                            </button>
                            {listeningMobile && (
                              <div className="absolute inset-0 bg-white bg-opacity-75 flex justify-center items-center z-10">
                                <span className="text-gray-900">
                                  Listening...
                                </span>
                              </div>
                            )}
                            {/* ========== FIXED: dropdown shows BOTH name and mobile ========== */}
                            {filteredCustomers.length > 0 && (
                              <div className="absolute bg-white border border-gray-300 mt-1 py-1 rounded w-full z-10 shadow-lg dark:border-gray-500 dark:bg-gray-800 max-h-60 overflow-auto">
                                {filteredCustomers.map((customer, index) => (
                                  <div
                                    key={customer.customer_mobile || index}
                                    onClick={() =>
                                      handleCustomerSelect(
                                        customer.customer_mobile,
                                        setFieldValue,
                                      )
                                    }
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        handleCustomerSelect(
                                          customer.customer_mobile,
                                          setFieldValue,
                                        );
                                      }
                                    }}
                                    tabIndex={0}
                                    role="button"
                                    className={`px-3 py-2 cursor-pointer hover:bg-blue-100 dark:hover:bg-gray-900 border-b border-gray-100 dark:border-gray-700 last:border-b-0 ${
                                      index === 0 ? "rounded-t" : ""
                                    } ${
                                      index === filteredCustomers.length - 1
                                        ? "rounded-b"
                                        : ""
                                    }`}
                                  >
                                    <div className="flex justify-between items-center">
                                      <span className="text-sm font-medium text-gray-800 dark:text-white">
                                        {customer.name || "Unnamed"}
                                      </span>
                                      <span className="text-xs text-gray-500 dark:text-gray-400">
                                        {customer.customer_mobile}
                                      </span>
                                    </div>
                                    {customer.customer_address && (
                                      <div className="text-xs text-gray-400 dark:text-gray-500 truncate">
                                        {customer.customer_address}
                                      </div>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>

                          <div className="col-span-1 relative">
                            <CustomField
                              type="text"
                              id="customerName"
                              label={t("FORM.CUSTOUMER_NAME")}
                              size="small"
                              name="customerName"
                              placeholder="Customer Name"
                              onKeyPress={onlyLetters}
                              onChange={(e) => {
                                handleChange(e);
                                setCustomerVoiceInput(e.target.value);
                              }}
                              value={values.customerName || customerVoiceInput}
                              className="w-full"
                              disabled={disableName}
                            />
                            <button
                              type="button"
                              onClick={() =>
                                handleCustomerNameVoiceSearch(setFieldValue)
                              }
                              className="absolute left-full ml-2 -mt-6"
                            >
                              <div className="relative w-5 h-6 bg-white flex justify-center items-center absolute bottom-1 right-10 dark:bg-gray-800">
                                <i
                                  className={`text-xl ${
                                    listeningCustomerName
                                      ? "text-green-400"
                                      : "text-blue-600"
                                  }`}
                                >
                                  <HiOutlineMicrophone />
                                </i>
                              </div>
                            </button>
                            {listeningCustomerName && (
                              <div className="absolute inset-0 bg-white bg-opacity-75 flex justify-center items-center z-10">
                                <span className="text-gray-900">
                                  Listening...
                                </span>
                              </div>
                            )}
                          </div>

                          <div className="col-span-1 sale-type-tour">
                            <CustomField
                              type="select"
                              name="saleType"
                              label={t("FORM.SALE_TYPE")}
                              placeholder="SaleType"
                              options={
                                item
                                  ? optionsForSaleTypeWithAdvance
                                  : saleTypeOptions
                              }
                              setFieldValue={setFieldValue}
                              handleChange={handleFormikChange}
                              handleBlur={handleBlur}
                              value={values.saleType}
                            />
                          </div>

                          <div className="col-span-1">
                            <CustomField
                              type="date"
                              name="saleDate"
                              label={t("FORM.SALE_DATE")}
                              placeholder="Sale Date"
                              handleChange={handleChange}
                              value={values.saleDate}
                            />
                          </div>
                        </div>

                        {showAdditionalFields && (
                          <div className="col-span-4 grid grid-cols-4 dark:bg-[#020617] gap-4 border-t border-gray-100 dark:border-gray-700 pt-4 mt-2 bg-white border rounded-lg p-4">
                            <div className="col-span-1 delivery-type-tour">
                              <CustomField
                                type="select"
                                name="deliveryType"
                                label={t("FORM.DELIVERY_TYPE")}
                                placeholder="Delivery Type"
                                options={optionsForDeliveryType}
                                setFieldValue={setFieldValue}
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                value={values.deliveryType}
                              />
                            </div>

                            <div className="col-span-2">
                              <CustomField
                                type="text"
                                name="address"
                                label={t("FORM.ADDRESS")}
                                placeholder="Address"
                                handleChange={handleChange}
                                value={values.address}
                              />
                            </div>

                            <div className="col-span-1">
                              <CustomField
                                type="select"
                                name="country"
                                label={t("FORM.COUNTRY")}
                                options={countries}
                                setFieldValue={setFieldValue}
                                handleChange={(e) =>
                                  handleCountryChange(
                                    setFieldValue,
                                    e?.target?.value,
                                  )
                                }
                                value={values.country}
                              />
                            </div>

                            <div className="col-span-1">
                              <CustomField
                                type="select"
                                name="state"
                                label={t("FORM.SATAE")}
                                placeholder="State"
                                handleChange={(e) =>
                                  setFieldValue("state", e?.target?.value)
                                }
                                options={states}
                                setFieldValue={setFieldValue}
                                value={values.state}
                              />
                            </div>

                            {values.deliveryType === "shedulePickup" && (
                              <>
                                <div className="col-span-1">
                                  <CustomField
                                    id="pickupDate"
                                    label={t("FORM.PICKUP_DATE")}
                                    type="date"
                                    onChange={handleChange}
                                    size="small"
                                    value={values.pickupDate}
                                    className="w-full"
                                    error={
                                      (values.saleType === "shedulePickup" &&
                                        values.pickupDate === "") ||
                                      (values.saleType === "shedulePickup" &&
                                        isPastDate(values.pickupDate))
                                        ? true
                                        : false
                                    }
                                    helperText={
                                      values.saleType === "shedulePickup" &&
                                      values.pickupDate === ""
                                        ? "Pickup Date is Required"
                                        : "" ||
                                            (values.saleType ===
                                              "shedulePickup" &&
                                              isPastDate(values.pickupDate))
                                          ? "Pickup Date Cannot Past"
                                          : ""
                                    }
                                  />
                                </div>
                                <div className="col-span-1">
                                  <CustomField
                                    id="pickupTime"
                                    label={t("FORM.PICKUP_TIME")}
                                    type="time"
                                    onChange={handleChange}
                                    size="small"
                                    value={values.pickupTime}
                                    className="w-full"
                                  />
                                </div>
                              </>
                            )}

                            <div className="col-span-2">
                              <CustomField
                                type="text"
                                name="notes"
                                label={t("FORM.NOTE")}
                                placeholder="Note"
                                handleChange={handleChange}
                                value={values.notes}
                              />
                            </div>

                            {(values.deliveryType === "homeDelivery" ||
                              values.saleType === "advanceSale" ||
                              values.saleType === "advancePayment") && (
                              <div className="col-span-4 grid grid-cols-4 gap-2 border-2 bg-orange-50 border-orange-500 dark:bg-[#170f2a] dark:border-orange-700 p-4 rounded-lg">
                                <div className="col-span-2">
                                  <CustomField
                                    type="textWithError"
                                    name="deliveryAddress"
                                    placeholder="Delivery Address"
                                    label={t("FORM.DELIVERY_ADDRESS")}
                                    handleChange={handleChange}
                                    value={values.deliveryAddress}
                                    error={
                                      values.deliveryType === "homeDelivery" &&
                                      values.deliveryAddress === ""
                                    }
                                    helperText={
                                      values.deliveryType === "homeDelivery" &&
                                      values.deliveryAddress === ""
                                        ? "Address is Required"
                                        : ""
                                    }
                                  />
                                </div>
                                <div>
                                  <CustomField
                                    id="deliveryDate"
                                    label={t("FORM.EXPECTED_DELIVERY")}
                                    type="date"
                                    onChange={handleChange}
                                    size="small"
                                    value={values.deliveryDate}
                                    helperText={
                                      isPastDate(values.deliveryDate)
                                        ? "Date cannot be Past Date"
                                        : ""
                                    }
                                    error={isPastDate(values.deliveryDate)}
                                    className="w-full"
                                  />
                                </div>
                                <div>
                                  <CustomField
                                    id="deliveryTime"
                                    label={t("FORM.EXPECTED_TIME")}
                                    type="time"
                                    onChange={handleChange}
                                    size="small"
                                    value={values.deliveryTime}
                                    inputProps={{
                                      step: 300,
                                    }}
                                    className="w-full"
                                  />
                                </div>
                                <div>
                                  <CustomField
                                    type="text"
                                    name="deliveryFee"
                                    label={t("FORM.DELIVERY_FEE")}
                                    placeholder="Delivery Fee"
                                    handleChange={handleDeliveryFeeChange}
                                    value={values.deliveryFee}
                                    onKeyPress={onlyNumberdesimal}
                                  />
                                </div>
                                <div>
                                  <CustomField
                                    type="text"
                                    name="assignedEmployee"
                                    label={t("FORM.ASSIGNED_EMPLOYEE")}
                                    placeholder="Delivery Person"
                                    handleChange={handleChange}
                                    value={values.assignedEmployee}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="flex items-center justify-between mt-2">
                        <div className="flex items-center">
                          <div className="flex items-center">
                            <div className="p-2 bg-gradient-to-br from-green-50 to-green-100 dark:from-green-900/20 dark:to-green-900/10 rounded-xl mr-3">
                              <svg
                                className="w-5 h-5 text-green-600 dark:text-green-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 4v16m8-8H4"
                                />
                              </svg>
                            </div>
                            <p className="text-sm text-green-700 font-semibold dark:text-green-400">
                              Add Items
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center space-x-4">
                          <div className="flex items-center space-x-4">
                            <FormControlLabel
                              control={
                                <Field
                                  as={Checkbox}
                                  name="isProducts"
                                  checked={isProducts}
                                  onChange={() => handleIsProduct(isProducts)}
                                  className="dark:text-white dark:checked:bg-white"
                                />
                              }
                              label={
                                <h6>
                                  <span className="text-sm text-blue-700 dark:text-white">
                                    {t("FORM.PRODUCTS")}
                                  </span>
                                </h6>
                              }
                            />

                            <FormControlLabel
                              control={
                                <Field
                                  as={Checkbox}
                                  name="isServices"
                                  checked={isServices}
                                  onChange={() => handleIsService(isServices)}
                                  className="dark:text-white dark:checked:bg-white"
                                />
                              }
                              label={
                                <h6>
                                  <span className="text-sm text-blue-700 dark:text-white">
                                    {t("FORM.SERVICE")}
                                  </span>
                                </h6>
                              }
                            />
                          </div>

                          <div className="relative">
                            <button
                              onClick={() => setShowFilter(!showFilter)}
                              className="flex items-center gap-2 px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm"
                              title="Add Custom Fields"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              <span>Add Fields</span>
                            </button>

                            {showFilter && (
                              <div className="absolute top-full right-0 mt-1 w-56 p-3 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-50">
                                <div className="flex justify-between items-center mb-2">
                                  <h4 className="text-sm font-semibold text-gray-800 dark:text-white">
                                    Available Fields
                                  </h4>
                                  <button
                                    onClick={() => setShowFilter(false)}
                                    className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 text-sm"
                                  >
                                    ✖️
                                  </button>
                                </div>

                                <div className="space-y-2">
                                  <div className="flex items-center justify-between py-1">
                                    <span className="text-xs font-medium text-gray-700 dark:text-gray-300">
                                      Select All
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={Object.values(
                                        visibleFields,
                                      ).every(Boolean)}
                                      onChange={handleToggleAllFields}
                                      className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                    />
                                  </div>

                                  {subscriptionEnabled && (
                                  <div className="flex items-center justify-between py-1">
                                    <span className="text-xs text-gray-700 dark:text-gray-300">
                                      Subscription
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={visibleFields.subscription}
                                      onChange={() =>
                                        handleFieldVisibility(
                                          "subscription",
                                          !visibleFields.subscription,
                                        )
                                      }
                                      className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                    />
                                  </div>
                                  )}

                                  {discountEnabled && (
                                  <>
                                  <div className="flex items-center justify-between py-1">
                                    <span className="text-xs text-gray-700 dark:text-gray-300">
                                      Discount
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={visibleFields.discount}
                                      onChange={() =>
                                        handleFieldVisibility(
                                          "discount",
                                          !visibleFields.discount,
                                        )
                                      }
                                      className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                    />
                                  </div>

                                  <div className="flex items-center justify-between py-1">
                                    <span className="text-xs text-gray-700 dark:text-gray-300">
                                      Discount Unit
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={visibleFields.disUnit}
                                      onChange={() =>
                                        handleFieldVisibility(
                                          "disUnit",
                                          !visibleFields.disUnit,
                                        )
                                      }
                                      className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                    />
                                  </div>
                                  </>
                                  )}

                                  {values.intraState && (
                                    <div className="flex items-center justify-between py-1">
                                      <span className="text-xs text-gray-700 dark:text-gray-300">
                                        IGST
                                      </span>
                                      <input
                                        type="checkbox"
                                        checked={visibleFields.igst}
                                        onChange={() =>
                                          handleFieldVisibility(
                                            "igst",
                                            !visibleFields.igst,
                                          )
                                        }
                                        className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                      />
                                    </div>
                                  )}

                                  {!values.intraState && (
                                    <div className="flex items-center justify-between py-1">
                                      <span className="text-xs text-gray-700 dark:text-gray-300">
                                        CGST
                                      </span>
                                      <input
                                        type="checkbox"
                                        checked={visibleFields.cgst}
                                        onChange={() =>
                                          handleFieldVisibility(
                                            "cgst",
                                            !visibleFields.cgst,
                                          )
                                        }
                                        className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                      />
                                    </div>
                                  )}

                                  {!values.intraState && (
                                    <div className="flex items-center justify-between py-1">
                                      <span className="text-xs text-gray-700 dark:text-gray-300">
                                        SGST
                                      </span>
                                      <input
                                        type="checkbox"
                                        checked={visibleFields.sgst}
                                        onChange={() =>
                                          handleFieldVisibility(
                                            "sgst",
                                            !visibleFields.sgst,
                                          )
                                        }
                                        className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                      />
                                    </div>
                                  )}

                                  <div className="flex items-center justify-between py-1">
                                    <span className="text-xs text-gray-700 dark:text-gray-300">
                                      CESS
                                    </span>
                                    <input
                                      type="checkbox"
                                      checked={visibleFields.cess}
                                      onChange={() =>
                                        handleFieldVisibility(
                                          "cess",
                                          !visibleFields.cess,
                                        )
                                      }
                                      className="h-3.5 w-3.5 text-blue-600 rounded focus:ring-blue-500"
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      {!isDisabled && (
  <div className="mb-3 flex items-center gap-3 p-3 rounded-lg border-2 border-dashed border-blue-300 bg-blue-50 dark:bg-gray-800 dark:border-blue-700">
    <FiPackage className="text-blue-600 dark:text-blue-400 text-xl shrink-0" />
    <input
      ref={scanInputRef}
      type="text"
      autoFocus
      autoComplete="off"
      placeholder="Scan the barcode using a scanner or type the barcode and press Enter."
      className="flex-1 py-2 px-3 border border-blue-300 dark:border-gray-600 dark:bg-gray-700 rounded text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
      onKeyDown={(e) => {
        const input = e.currentTarget;
        if (e.key === "Enter" || (e.key === "Tab" && input.value)) {
          e.preventDefault(); 
          e.stopPropagation();
          const val = input.value;
          input.value = "";
          handleBarcodeScan(val);
        }
      }}
    />
    {lastScan && (
      <span
        className={`text-xs font-medium truncate max-w-[40%] ${
          lastScan.ok ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400"
        }`}
      >
        {lastScan.ok ? "✓" : "✗"} {lastScan.msg}
      </span>
    )}
  </div>
)}

                      <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-4 bg-gray-50 dark:bg-[#020617]">
                        <div className="overflow-x-auto whitespace-nowrap">
                          <div className="min-w-[1200px] overflow-x-auto scroll-h-6 ">
                            <div className="w-full">
                              <div className="grid grid-cols-12 gap-1 bg-green-50 border-2 border-green-300 dark:bg-gray-800 dark:border-green-700 p-2 rounded-lg">
                                <div className="col-span-5">
                                  <div className="grid grid-cols-5 gap-4">
                                    <div className="col-span-2">
                                      <label
                                        htmlFor={
                                          isServices
                                            ? "serviceName"
                                            : "productNameEAN"
                                        }
                                        className="text-xs font-medium text-gray-800 dark:text-white block mb-1"
                                      >
                                        {isServices
                                          ? t("REPORT.SERVICE_NAME")
                                          : t("REPORT.PRODUCT_NAME_EAN")}
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="quantity"
                                        className="text-xs font-medium text-gray-800 dark:text-white block mb-1"
                                      >
                                        {t("FORM.QUANTITY")}
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="unit"
                                        className="text-xs font-medium text-gray-800 dark:text-white block mb-1"
                                      >
                                        Unit
                                      </label>
                                    </div>
                                    <div>
                                      <label
                                        htmlFor="salePrice"
                                        className="text-xs font-medium text-gray-800 dark:text-white block mb-1"
                                      >
                                        {t("FORM.SALE_PRICE")}
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-span-1">
                                  <label
                                    htmlFor="finalPrice"
                                    className="text-xs font-medium text-gray-800 dark:text-white block mb-1"
                                  >
                                    {t("FORM.FINAL_PRICE")}
                                  </label>
                                </div>

                                <div className="col-span-5">
                                  <div className="grid grid-cols-5 gap-4">
                                    {visibleFields.subscription && (
                                      <div>
                                        <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                          {t("FORM.SUBSCRIPTION")}
                                        </label>
                                      </div>
                                    )}

                                    <div className="grid grid-cols-2 gap-2">
                                      {visibleFields.discount && (
                                        <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                          Discount & Unit
                                        </label>
                                      )}
                                    </div>

                                    {values.intraState === true &&
                                      visibleFields.igst && (
                                        <div>
                                          <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                            {t("TAX_WITHOUT_PERC.IGST")}
                                          </label>
                                        </div>
                                      )}

                                    {values.intraState === false &&
                                      visibleFields.cgst && (
                                        <div>
                                          <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                            {t("TAX_WITHOUT_PERC.CGST")}
                                          </label>
                                        </div>
                                      )}

                                    {values.intraState === false &&
                                      visibleFields.sgst && (
                                        <div>
                                          <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                            {t("TAX_WITHOUT_PERC.SGST")}
                                          </label>
                                        </div>
                                      )}

                                    {visibleFields.cess && (
                                      <div>
                                        <label className="text-xs font-medium text-gray-800 dark:text-white block mb-1">
                                          {t("TAX_WITHOUT_PERC.CESS")}
                                        </label>
                                      </div>
                                    )}
                                  </div>
                                </div>

                                <div className="col-span-1"></div>
                              </div>

                              <div className="space-y-3 mt-2">
                                {productSections.map((section, index) => (
                                  <div
                                    key={index}
                                    className="grid grid-cols-12 gap-4 p-1 bg-white dark:bg-[#170f2a] rounded-lg border border-gray-200 dark:border-gray-700 min-h-[60px] items-center"
                                    style={{ minHeight: "60px" }}
                                  >
                                    <div className="col-span-5 flex items-center min-h-[48px] h-12">
                                      <div className="grid grid-cols-5 gap-4 w-full h-full items-center">
                                      <div className="col-span-2 relative">
  <div className="flex items-center gap-2">
    {/* Input wrapper — mic stays inside this */}
    <div className="relative flex-1">
      <input
        type="text"
        id={`productName${index + 1}`}
        placeholder={
          isServices
            ? t("REPORT.SERVICE_NAME")
            : t("REPORT.PRODUCT_NAME_EAN")
        }
        className="w-full py-1 pl-2 pr-8 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
        value={section.productName}
        onChange={(e) =>
                                                handleInputChange(
                                                  index,
                                                  "productName",
                                                  e.target.value,
                                                )
        }
        onBlur={handleBlur}
        onKeyUp={(e) => handleInputSearch(e, index)}
      />

      {/* Mic button — right side of the input box */}
      <button
        type="button"
        onClick={() => handleVoiceSearch(index)}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
        title="Search product by voice"
      >
        <HiOutlineMicrophone
          className={`text-lg ${listening ? "text-green-500 animate-pulse" : ""}`}
        />
      </button>
    </div>

    {/* Variant button — separate sibling, no overlap */}
    {section.hasVariants && (
      <button
        type="button"
                                                onClick={() =>
                                                  handleSelectVariantClick(
                                                    index,
                                                  )
                                                }
                                                className={`px-2 py-1 text-xs font-medium rounded ${
          section.variantId
            ? "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300"
            : "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300"
        }`}
        title={
          section.variantId
            ? `Selected: ${section.variantName}`
            : "Select variant"
        }
      >
        {section.variantId ? (
          <div className="flex items-center gap-1">
            <span className="truncate max-w-[80px]">
              {section.variantName}
            </span>
            <svg
              className="w-3 h-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        ) : (
          "Select Variant"
        )}
      </button>
    )}
  </div>

                                
                                          {activeIndex === index &&
                                            listening && (
    <div className="absolute inset-0 bg-white bg-opacity-90 dark:bg-gray-800 dark:bg-opacity-90 flex items-center justify-center rounded">
      <span className="text-gray-800 dark:text-white font-medium text-xs">
        Listening...
      </span>
    </div>
  )}
                                          {searchResults.length > 0 &&
                                            activeIndex === index && (
    <div className="absolute z-10 mt-1 w-full bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded shadow-lg max-h-60 overflow-auto text-sm">
                                                {searchResults.map(
                                                  (product, i) => (
        <div
          key={i}
                                                      onClick={() =>
                                                        handleSelectProduct(
                                                          product,
                                                          index,
                                                        )
                                                      }
          className="px-2 py-1.5 hover:bg-blue-50 dark:hover:bg-gray-600 cursor-pointer"
        >
          <div className="flex justify-between items-center">
                                                        <span>
                                                          {product.productName ||
                                                            product.serviceName}
                                                        </span>
            {product.hasVariants && (
              <span className="text-xs bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300 px-1.5 py-0.5 rounded">
                Variants
              </span>
            )}
          </div>
          {product?.batchNumber && (
            <span className="text-xs text-gray-500 dark:text-gray-400 ml-1">
                                                          Batch:{" "}
                                                          {product.batchNumber}
            </span>
          )}
        </div>
                                                  ),
                                                )}
    </div>
  )}
  {section.bulkPriceEligible && (
    <p className="text-xs text-green-600 dark:text-green-400 mt-1 font-medium">
      Buy more & save
    </p>
  )}

                                          {section.variantAttributes &&
                                            section.variantAttributes.length >
                                              0 && (
    <div className="flex flex-wrap gap-1 mt-1">
                                                {section.variantAttributes.map(
                                                  (attr, attrIndex) => (
        <span
          key={attrIndex}
          className="px-1.5 py-0.5 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 text-xs rounded-full"
        >
          {attr.type}: {attr.value}
        </span>
                                                  ),
                                                )}
    </div>
  )}
</div>

                                        <div>
                                          <div className="flex items-center border rounded">
                                            <button
                                              type="button"
                                              onClick={() =>
                                                handleQuantityChange(index, -1)
                                              }
                                              className="px-1 py-1 text-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600 text-sm"
                                              disabled={
                                                section.hasVariants &&
                                                !section.variantId
                                              }
                                            >
                                              −
                                            </button>
                                            <input
                                              type="text"
                                              id={`quantity${index + 1}`}
                                              value={section.quantity}
                                              className="w-12 px-2 py-1 text-center border-x border-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:outline-none text-sm"
                                              inputMode="decimal"
onKeyPress={onlyNumberdesimal}
                                              // onKeyPress={onlyNumber}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  index,
                                                  "quantity",
                                                  e.target.value,
                                                )
                                              }
                                              disabled={
                                                section.hasVariants &&
                                                !section.variantId
                                              }
                                            />
                                            <button
                                              type="button"
                                              onClick={() =>
                                                handleQuantityChange(index, 1)
                                              }
                                              className="px-1 py-1 text-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-600 text-sm"
                                              disabled={
                                                section.hasVariants &&
                                                !section.variantId
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                          {section.hasVariants &&
                                            section.variantId &&
                                            section.variantDetails && (
                                              <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                                Stock:{" "}
                                                {
                                                  section.variantDetails
                                                    .quantity
                                                }
                                              </div>
                                            )}
                                        </div>
                                        <div>
                                          {section.additionalUnit &&
                                          Number(section.conversionQty) > 0 &&
                                          !section.hasVariants ? (
                                            <select
                                              className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded text-sm"
                                              value={
                                                section.saleUnitType ===
                                                "additional"
                                                  ? "additional"
                                                  : "main"
                                              }
                                              onChange={(e) =>
                                                handleSaleUnitChange(
                                                  index,
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              <option value="main">
  {section.baseUnitSize}
</option>
                                              <option value="additional">
                                                {section.additionalUnit}
                                              </option>
                                            </select>
                                          ) : (
                                            <input
                                              type="text"
                                              placeholder="Unit"
                                              className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded text-sm"
                                              value={section.unitSize || ""}
                                              disabled
                                            />
                                          )}
                                        </div>
                                        <div>
                                          <input
                                            type="text"
                                            id={`salePrice${index + 1}`}
                                            placeholder="Sale Price"
                                            className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                            value={section.salePrice}
                                            onKeyPress={onlyNumberdesimal}
                                            onChange={(e) =>
                                              handleInputChange(
                                                index,
                                                "salePrice",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-span-1 flex items-center min-h-[48px] h-12">
                                      <input
                                        type="text"
                                        id={`finalPrice${index + 1}`}
                                        placeholder="Price"
                                        className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded bg-gray-100 dark:bg-gray-600 text-sm"
                                        value={section.finalPrice}
                                        disabled={item ? false : true}
                                      />
                                    </div>

                                    <div className="col-span-5 flex items-center min-h-[48px] h-12">
                                      <div className="grid grid-cols-5 gap-4 w-full h-full items-center">
                                        {visibleFields.subscription && (
                                          <div>
                                            <CustomField
                                              type="select"
                                              name="subscriptionType"
                                              placeholder="Subscription"
                                              options={
                                                section.subscriptionEligible ===
                                                true
                                                  ? section?.subscriptionOption
                                                  : []
                                              }
                                              handleChange={(e) =>
                                                handleInputChange(
                                                  index,
                                                  "subscriptionType",
                                                  e.target.value,
                                                )
                                              }
                                              defaultHandleChange={false}
                                              handleBlur={handleBlur}
                                              value={section.subscriptionType}
                                              selectPropClass=" py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded text-sm"
                                              disabled={
                                                section.subscriptionEligible ===
                                                true
                                                  ? false
                                                  : true
                                              }
                                              helperText={
                                                section.subscriptionEligible ===
                                                false
                                                  ? `Not${"\u00A0"}Applicable`
                                                  : ""
                                              }
                                            />
                                          </div>
                                        )}

                                        <div className="col-span-1">
                                          <div className="grid grid-cols-2 gap-2">
                                            {visibleFields.discount && (
                                              <div>
                                                <input
                                                  type="text"
                                                  id={`discount${index + 1}`}
                                                  placeholder="Discount"
                                                  className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 
                    dark:bg-gray-700 rounded text-sm focus:ring-1 focus:ring-blue-500 
                    focus:border-blue-500"
                                                  value={section.discount}
                                                  onKeyPress={
                                                    onlyNumberWithExpression
                                                  }
                                                  onChange={(e) =>
                                                    handleInputChange(
                                                      index,
                                                      "discount",
                                                      e.target.value,
                                                    )
                                                  }
                                                />
                                              </div>
                                            )}

                                            {visibleFields.disUnit && (
                                              <div>
                                                <select
                                                  className="w-full py-1 border border-gray-300 dark:border-gray-600 
                    dark:bg-gray-700 rounded text-sm focus:ring-1 focus:ring-blue-500 
                    focus:border-blue-500"
                                                  name="discountUnit"
                                                  onChange={(e) =>
                                                    handleInputChange(
                                                      index,
                                                      "discountUnit",
                                                      e.target.value,
                                                    )
                                                  }
                                                  value={section.discountUnit}
                                                >
                                                  <option value="%">%</option>
                                                  <option value="₹">₹</option>
                                                </select>
                                              </div>
                                            )}
                                          </div>
                                        </div>

                                        {values.intraState === true &&
                                          visibleFields.igst && (
                                            <div>
                                              <input
                                                type="text"
                                                id={`igst${index + 1}`}
                                                placeholder="IGST"
                                                className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                value={section.igst}
                                                onKeyPress={onlyNumber}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    index,
                                                    "igst",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          )}

                                        {values.intraState === false &&
                                          visibleFields.cgst && (
                                            <div>
                                              <input
                                                type="text"
                                                id={`cgst${index + 1}`}
                                                placeholder="CGST"
                                                className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                value={section.cgst}
                                                onKeyPress={onlyNumber}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    index,
                                                    "cgst",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          )}

                                        {values.intraState === false &&
                                          visibleFields.sgst && (
                                            <div>
                                              <input
                                                type="text"
                                                id={`sgst_utgst${index + 1}`}
                                                placeholder="SGST"
                                                className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                                value={section.sgst_utgst}
                                                onKeyPress={onlyNumber}
                                                onChange={(e) =>
                                                  handleInputChange(
                                                    index,
                                                    "sgst_utgst",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </div>
                                          )}

                                        {visibleFields.cess && (
                                          <div>
                                            <input
                                              type="text"
                                              id={`cess${index + 1}`}
                                              placeholder="CESS"
                                              className="w-full py-1 px-2 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 rounded focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm"
                                              value={section.cess}
                                              onKeyPress={onlyNumber}
                                              onChange={(e) =>
                                                handleInputChange(
                                                  index,
                                                  "cess",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </div>

                                    <div className="col-span-1 flex justify-end items-center gap-1 min-h-[48px] h-12">
                                      <button
                                        type="button"
                                        onClick={handleAddProductSection}
                                        className="p-1 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-gray-700 rounded-full"
                                        title="Add More Rows"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className="h-4 w-4"
                                          viewBox="0 0 20 20"
                                          fill="currentColor"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                            clipRule="evenodd"
                                          />
                                        </svg>
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleDeleteProductSection(index)
                                        }
                                        className="p-1 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-gray-700 rounded-full"
                                        title="Remove Row"
                                      >
                                        <BsTrash className="h-4 w-4" />
                                      </button>
                                    </div>
                                  </div>
                                ))}
                                {showPopup && (
                                  <Modal
                                    isOpen={showPopup}
                                    width="25%"
                                    closeModal={handleShowPopup}
                                    modalHeader="Select Dates"
                                  >
                                    <DateSelector
                                      handleAddDate={(
                                        startDate,
                                        endDate,
                                        occurrence,
                                      ) =>
                                        handleAddDate(
                                          startDate,
                                          endDate,
                                          occurrence,
                                          setFieldValue,
                                        )
                                      }
                                      handleShowPopup={handleShowPopup}
                                    />
                                  </Modal>
                                )}
                              </div>
                            </div>

                            <div className="mt-3">
                              <button
                                type="button"
                                onClick={handleIsOpen}
                                disabled={
                                  isServices
                                    ? service.length === 0
                                    : products.length === 0
                                }
                                className={`flex items-center gap-1 px-3 py-1 rounded-lg text-sm ${
                                  (isServices && service.length === 0) ||
                                  (!isServices && products.length === 0)
                                    ? "bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed"
                                    : "bg-blue-600 hover:bg-blue-700 text-white"
                                }`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                                <span>{t("FORM.SELECT_INVENTORY")}</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                        <div className="bg-gradient-to-br from-gray-50 to-white dark:from-[#170f2a] dark:to-[#1e153a] p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800">
                          <div className="flex items-center justify-between mb-3">
                            <h4 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-1.5">
                              <div className="w-1.5 h-3.5 bg-blue-500 rounded-full"></div>
                              Tax Summary
                            </h4>
                            <span className="text-xs px-1.5 py-0.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300 rounded-full">
                              {values.intraState
                                ? "Inter-State"
                                : "Intra-State"}
                            </span>
                          </div>

                          <div className="space-y-2">
                            {values.intraState === true &&
                              visibleFields.igst && (
                                <div className="flex justify-between items-center p-2 bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700">
                                  <div className="flex items-center gap-1.5">
                                    <div className="w-1.5 h-1.5 rounded-full bg-purple-500"></div>
                                    <span className="text-xs text-gray-700 dark:text-gray-300">
                                      {t("TAX_WITHOUT_PERC.IGST")}
                                    </span>
                                  </div>
                                  <span className="text-xs font-semibold text-gray-900 dark:text-white">
                                    {igst}
                                  </span>
                                </div>
                              )}

                            {values.intraState === false && (
                              <>
                                {visibleFields.cgst && (
                                  <div className="flex justify-between items-center p-2 bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700">
                                    <div className="flex items-center gap-1.5">
                                      <div className="w-1.5 h-1.5 rounded-full bg-blue-500"></div>
                                      <span className="text-xs text-gray-700 dark:text-gray-300">
                                        {t("TAX_WITHOUT_PERC.CGST")}
                                      </span>
                                    </div>
                                    <span className="text-xs font-semibold text-gray-900 dark:text-white">
                                      {cgst}
                                    </span>
                                  </div>
                                )}
                                {visibleFields.sgst && (
                                  <div className="flex justify-between items-center p-2 bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700">
                                    <div className="flex items-center gap-1.5">
                                      <div className="w-1.5 h-1.5 rounded-full bg-green-500"></div>
                                      <span className="text-xs text-gray-700 dark:text-gray-300">
                                        {t("TAX_WITHOUT_PERC.SGST")}
                                      </span>
                                    </div>
                                    <span className="text-xs font-semibold text-gray-900 dark:text-white">
                                      {sgst}
                                    </span>
                                  </div>
                                )}
                              </>
                            )}

                            {visibleFields.cess && (
                              <div className="flex justify-between items-center p-2 bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700">
                                <div className="flex items-center gap-1.5">
                                  <div className="w-1.5 h-1.5 rounded-full bg-orange-500"></div>
                                  <span className="text-xs text-gray-700 dark:text-gray-300">
                                    {t("TAX_WITHOUT_PERC.CESS")}
                                  </span>
                                </div>
                                <span className="text-xs font-semibold text-gray-900 dark:text-white">
                                  {cess}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="bg-gradient-to-br from-gray-50 to-white dark:from-[#170f2a] dark:to-[#1e153a] p-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800">
                          <div className="flex items-center justify-between mb-3">
                            <h4 className="text-sm font-semibold text-gray-800 dark:text-white flex items-center gap-1.5">
                              <div className="w-1.5 h-3.5 bg-emerald-500 rounded-full"></div>
                              Pricing Summary
                            </h4>
                            <span className="text-xs px-1.5 py-0.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-300 rounded-full">
                              {productSections.length} Items
                            </span>
                          </div>

                          <div className="space-y-3">
                            {discountEnabled && (
                            <div className="bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700 p-3">
                              <div className="flex items-center justify-between mb-2">
                                <label className="text-xs font-medium text-gray-700 dark:text-gray-300 flex items-center gap-1.5">
                                  <div className="w-1.5 h-1.5 rounded-full bg-amber-500"></div>
                                  {t("INVOICE.ADDITIONAL_DISCOUNT")}
                                </label>
                                <span className="text-xs text-gray-500 dark:text-gray-400">
                                  {values.additionalDiscount.length} applied
                                </span>
                              </div>

                              <div className="space-y-1.5">
                                {values.additionalDiscount.map(
                                  (item, index) => (
                                    <div
                                      key={index}
                                      className="flex items-center gap-1.5 p-1.5 bg-gray-50 dark:bg-gray-800/80 rounded-lg"
                                    >
                                      <input
                                        name={`additionalDiscount.${index}.label`}
                                        type="text"
                                        placeholder="Discount label"
                                        className="flex-1 py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                        value={item.label}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                      <div className="flex items-center gap-1 flex-1">
                                        <select
                                          name={`additionalDiscount.${index}.type`}
                                          className="py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                          value={item.type || "%"}
                                          onChange={handleFormikChange}
                                        >
                                          <option value="%">%</option>
                                          <option value="₹">₹</option>
                                        </select>
                                        <input
                                          name={`additionalDiscount.${index}.amount`}
                                          type="text"
                                          placeholder="0.00"
                                          className="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                          value={item.amount}
                                          onChange={handleFormikChange}
                                          onBlur={handleBlur}
                                          maxLength={6}
                                        />
                                      </div>
                                      <button
                                        type="button"
                                        onClick={() => removeDiscount(index)}
                                        className="p-1.5 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                                        aria-label="Remove discount"
                                      >
                                        <BsTrash className="h-3 w-3" />
                                      </button>
                                    </div>
                                  ),
                                )}
                              </div>

                              <button
                                type="button"
                                onClick={addDiscount}
                                className="mt-2 w-full py-1.5 px-2.5 border border-dashed border-gray-300 dark:border-gray-600 hover:border-blue-500 dark:hover:border-blue-400 rounded-lg text-xs text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-300 flex items-center justify-center gap-1.5 transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-3 w-3"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                  />
                                </svg>
                                Add Discount
                              </button>
                            </div>
                            )}

                            {visibleFields.subscription && (
                              <div className="flex justify-between items-center p-2 bg-emerald-50 dark:bg-emerald-900/20 rounded-lg border border-emerald-100 dark:border-emerald-800">
                                <div className="flex items-center gap-1.5">
                                  <div className="w-1.5 h-1.5 rounded-full bg-emerald-500"></div>
                                  <span className="text-xs text-gray-700 dark:text-gray-300">
                                    {t("INVOICE.SUBSCRIPTION_SAVINGS")}
                                  </span>
                                </div>
                                <span className="text-xs font-semibold text-emerald-600 dark:text-emerald-400">
                                  -{getCurrencySymbol(business?.currency)}
                                  {calculateTotalSubscriptionSaving(
                                    productSections,
                                  )}
                                </span>
                              </div>
                            )}

                            <div className="bg-white dark:bg-gray-800/50 rounded-lg border border-gray-100 dark:border-gray-700 p-3">
                              <div className="flex items-center justify-between mb-2">
                                <label className="text-xs font-medium text-gray-700 dark:text-gray-300 flex items-center gap-1.5">
                                  <div className="w-1.5 h-1.5 rounded-full bg-rose-500"></div>
                                  {t("INVOICE.ADDITIONAL_FEE")}
                                </label>
                                <span className="text-xs text-gray-500 dark:text-gray-400">
                                  {values.additionalFee.length} applied
                                </span>
                              </div>

                              <div className="space-y-1.5">
                                {values.additionalFee.map((item, index) => (
                                  <div
                                    key={index}
                                    className="flex items-center gap-1.5 p-1.5 bg-gray-50 dark:bg-gray-800/80 rounded-lg"
                                  >
                                    <input
                                      name={`additionalFee.${index}.label`}
                                      type="text"
                                      placeholder="Fee label"
                                      className="flex-1 py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                      value={item.label}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    <div className="flex items-center gap-1 flex-1">
                                      <select
                                        name={`additionalFee.${index}.type`}
                                        className="py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                        value={item.type || "%"}
                                        onChange={handleFormikChange}
                                      >
                                        <option value="%">%</option>
                                        <option value="₹">₹</option>
                                      </select>
                                      <input
                                        name={`additionalFee.${index}.amount`}
                                        type="text"
                                        placeholder="0.00"
                                        className="w-full py-1.5 px-2.5 border border-gray-200 dark:border-gray-700 dark:bg-gray-900 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                        value={item.amount}
                                        onChange={handleFormikChange}
                                        onBlur={handleBlur}
                                        maxLength={6}
                                      />
                                    </div>
                                    <button
                                      type="button"
                                      onClick={() => removeFee(index)}
                                      className="p-1.5 text-red-500 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors"
                                      aria-label="Remove fee"
                                    >
                                      <BsTrash className="h-3 w-3" />
                                    </button>
                                  </div>
                                ))}
                              </div>

                              <button
                                type="button"
                                onClick={addFee}
                                className="mt-2 w-full py-1.5 px-2.5 border border-dashed border-gray-300 dark:border-gray-600 hover:border-rose-500 dark:hover:border-rose-400 rounded-lg text-xs text-gray-600 dark:text-gray-400 hover:text-rose-600 dark:hover:text-rose-300 flex items-center justify-center gap-1.5 transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-3 w-3"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                  />
                                </svg>
                                Add Fee
                              </button>
                            </div>

                            {(values.saleType === "advanceSale" ||
                              values.saleType === "advancePayment") && (
                              <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-100 dark:border-blue-800 p-3">
                                <h5 className="text-xs font-medium text-blue-700 dark:text-blue-300 mb-2 flex items-center gap-1.5">
                                  <svg
                                    className="w-3 h-3"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm12 2a1 1 0 10-2 0v1H4V6a1 1 0 011-1h12a1 1 0 011 1z"
                                      clipRule="evenodd"
                                    />
                                  </svg>
                                  Advance Payment Details
                                </h5>

                                <div className="space-y-2">
                                  <div className="flex justify-between items-center p-1.5">
                                    <span className="text-xs text-gray-700 dark:text-gray-300">
                                      {t("SIDER.ADVANCE_AMOUNT")}
                                    </span>
                                    <div className="relative">
                                      <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs">
                                        {getCurrencySymbol(business?.currency)}
                                      </span>
                                      <input
                                        name="advancePayment"
                                        type="text"
                                        className="w-28 py-1.5 pl-6 pr-2.5 border border-gray-300 dark:border-gray-600 dark:bg-gray-800 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                        value={advanceAmount}
                                        onChange={(e) =>
                                          setAdvanecAmount(e.target.value)
                                        }
                                        onKeyPress={onlyNumberdesimal}
                                        placeholder="0.00"
                                      />
                                    </div>
                                  </div>

                                  {item && (
                                    <div className="flex justify-between items-center p-1.5">
                                      <span className="text-xs text-gray-700 dark:text-gray-300">
                                        {t("FORM.MORE_ADVANCE_AMOUNT")}
                                      </span>
                                      <div className="relative">
                                        <span className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 text-xs">
                                          {getCurrencySymbol(
                                            business?.currency,
                                          )}
                                        </span>
                                        <input
                                          name="moreAdvancePayment"
                                          type="text"
                                          className="w-28 py-1.5 pl-6 pr-2.5 border border-gray-300 dark:border-gray-600 dark:bg-gray-800 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                          value={moreAdvancePayment}
                                          onChange={(e) =>
                                            setMoreAdvancePayment(
                                              e.target.value,
                                            )
                                          }
                                          onKeyPress={onlyNumberdesimal}
                                          placeholder="0.00"
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}

                            <div className="mt-3 flex gap-2 items-center">
                              <div className="relative flex-1">
                                <input
                                  type="text"
                                  placeholder={t("COUPON.ORDER_COUPON_CODE")}
                                  value={orderCouponCode}
                                  onChange={(e) =>
                                    setOrderCouponCode(e.target.value)
                                  }
                                  className="w-full py-1.5 px-2.5 border border-gray-300 dark:border-gray-600 dark:bg-gray-800 rounded-lg text-xs focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                                />
                              </div>

                              <button
                                onClick={handleApplyOrderCoupon}
                                className="py-1.5 px-3 bg-green-500 hover:bg-green-600 text-white text-xs rounded-lg transition-colors"
                              >
                                {t("COMMON.APPLY")}
                              </button>

                              {appliedOrderCoupon && (
                                <button
                                  onClick={removeOrderCoupon}
                                  className="py-1.5 px-3 bg-red-500 hover:bg-red-600 text-white text-xs rounded-lg transition-colors"
                                >
                                  {t("PAYMENT.REMOVE")}
                                </button>
                              )}
                            </div>

                            {appliedOrderCoupon && (
                              <div className="mt-1.5 text-xs text-green-600 dark:text-green-400 pl-1">
                                {t("COUPON.APPLIED")}:{" "}
                                <span className="font-medium">
                                  {appliedOrderCoupon}
                                </span>{" "}
                                —{appliedCouponType} — ₹{orderCouponDiscount}{" "}
                                off
                              </div>
                            )}

                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/30 dark:to-indigo-900/30 rounded-lg border border-blue-200 dark:border-blue-800 p-3">
                              <div className="flex justify-between items-center">
                                <div>
                                  <span className="text-xs font-semibold text-gray-800 dark:text-white">
                                    {values.saleType === "advanceSale" ||
                                    values.saleType === "advancePayment"
                                      ? t("SIDER.REMAINING_AMOUNT")
                                      : t("REPORT.TOTAL_AMOUNT")}
                                  </span>
                                  {values.saleType === "advanceSale" ||
                                    (values.saleType === "advancePayment" && (
                                      <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                                        After advance payment
                                      </p>
                                    ))}
                                </div>
                                <span className="text-sm font-bold text-blue-600 dark:text-blue-400">
                                  {getCurrencySymbol(business?.currency)}
                                  {(
                                    calculateTotalTransactionAmount(values) -
                                    calculateTotalSubscriptionSaving(
                                      productSections,
                                    )
                                  ).toFixed(2)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mt-4 flex flex-col sm:flex-row gap-2">
                        {values.saleType === "estimate" ? (
                          <button
                            type="button"
                            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg text-sm w-full sm:w-auto"
                            onClick={() => handlePrintReceipt(values)}
                            disabled={
                              !values.customerName ||
                              !productSections[0].productName
                            }
                          >
                            {t("FORM.PRINT_ESTIMATE")}
                          </button>
                        ) : values.saleType === "advancePayment" ? (
                          !isDisabled && (
                            <button
                              type="button"
                              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm w-full sm:w-auto"
                              onClick={handleIsOpenForFullPayment}
                            >
                              {t("FORM.PAY_ADVANCE_AMOUNT")}
                            </button>
                          )
                        ) : (
                          <>
                            {!isDisabled && (
                              <button
                                type="button"
                                className={`w-1/2 py-2 border border-blue-700 text-blue-700 mt-4 font-bold rounded ${
                                  !values.mobile && !values.customerName
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                                onClick={handleIsOpenForPayParial}
                                disabled={
                                  !values.mobile && !values.customerName
                                }
                                title={
                                  !values.mobile && !values.customerName
                                    ? "Please enter customer name and mobile to proceed"
                                    : ""
                                }
                              >
                                {t("FORM.PAY_PARTIAL_BUTTOM")}
                                {saleIsLoading && (
                                  <BeatLoader
                                    color="#3b82f6"
                                    size={8}
                                    className="ml-1"
                                  />
                                )}
                              </button>
                            )}
                            {!isDisabled && (
                              <button
                                type="button"
                                className={`w-1/2 py-2 px-2 bg-blue-600 text-white hover:bg-blue-700 mt-4 font-bold rounded ${
                                  !values.customerName ||
                                  !values.mobile ||
                                  saleIsLoading ||
                                  (values.deliveryType === "homeDelivery" &&
                                    values.deliveryAddress === "")
                                    ? "opacity-50 cursor-not-allowed"
                                    : ""
                                }`}
                                onClick={handleIsOpenForFullPayment}
                                disabled={
                                  !values.customerName ||
                                  !values.mobile ||
                                  saleIsLoading ||
                                  (values.deliveryType === "homeDelivery" &&
                                    values.deliveryAddress === "")
                                }
                                title={
                                  !values.mobile && !values.customerName
                                    ? "Please enter customer name and mobile to proceed"
                                    : ""
                                }
                              >
                                {t("FORM.PAY_FULL_BUTTOM")}
                                {saleIsLoading && (
                                  <BeatLoader color="#5556d3" size={14} />
                                )}
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <Modal
                  isOpen={isOpen}
                  width="70%"
                  closeModal={handleIsOpen}
                  modalHeader={
                    isServices === true
                      ? t("PAGINATION.SELECT_SERVICE")
                      : t("PAGINATION.SELECT_PRODUCT")
                  }
                >
                  <ProductSelection
                    products={isServices === true ? service : products}
                    handleSelectedProducts={handleSelectedProducts}
                    handleIsOpen={handleIsOpen}
                    isServices={isServices === true ? true : false}
                  />
                </Modal>
                <Modal
                  isOpen={isOpenFullPayment}
                  width="20%"
                  closeModal={handleIsOpenForFullPayment}
                  modalHeader={t("PAGINATION.PAYMENT_OPTION")}
                >
                  {saleIsLoading ? (
                    <div className="flex justify-center items-center h-full">
                      <BeatLoader color="#5556d3" size={12} />
                    </div>
                  ) : (
                    <PaymentOptions
                      handleChangePaymentMethod={handleChangePaymentMethod}
                      values={values}
                      businessUuid={finalBusinessUuid}
                      allowScanner={!item && values.saleType !== "advancePayment"}
                      totalAmount={
                        values.saleType === "advancePayment"
                          ? item
                            ? moreAdvancePayment
                            : advanceAmount
                          : (
                              calculateTotalTransactionAmount(values) -
                              calculateTotalSubscriptionSaving(productSections)
                            ).toFixed(2)
                      }
                    />
                  )}
                </Modal>
                <Modal
                  isOpen={isOpenPayPartial}
                  width="40%"
                  closeModal={handleIsOpenForPayParial}
                  modalHeader="Pay Partial"
                >
                  {saleIsLoading ? (
                    <div className="flex justify-center items-center h-full">
                      <BeatLoader color="#5556d3" size={12} />
                    </div>
                  ) : (
                    <SalePaylater
                      handleChangePaymentMethod={handleChangePaymentMethod}
                      totalAmount={
                        item
                          ? item.remainingTransactionAmount
                          : (
                              calculateTotalTransactionAmount(values) -
                              calculateTotalSubscriptionSaving(productSections)
                            ).toFixed(2)
                      }
                      values={values}
                    />
                  )}
                </Modal>
                <SaleQrPaymentModal
                  businessUuid={finalBusinessUuid}
                  session={qrSession}
                  onPaid={handleQrPaid}
                  onClose={() => setQrSession(null)}
                />
              </Form>
            );
          }}
        </Formik>
      ) : (
        <SaleInvoice close={closeInvoice} productSections={productSections} />
      )}
    </>
  );
};

export default NewSale;